var _defs, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgServerDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 824.281,
    height: 412.61,
    viewBox: "0 0 824.281 412.61",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -0.642,
    y1: 0.416,
    x2: 0.356,
    y2: 0.416,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#34254c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#51397f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -0.199,
    y1: 0.486,
    x2: 0.391,
    y2: 0.486,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e1dae5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f7f4f9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -2.558,
    y1: 0.083,
    x2: -1.432,
    y2: 0.083,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c8b8d3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c8b8d3",
    stopOpacity: 0.302
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -0.831,
    y1: 0.414,
    x2: 0.337,
    y2: 0.414,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: -3.422,
    y1: 0.433,
    x2: -2.185,
    y2: 0.433,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c8b8d3",
    stopOpacity: 0.902
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c8b8d3",
    stopOpacity: 0.302
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: -0.97,
    y1: 0.401,
    x2: 0.147,
    y2: 0.401,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: -2.041,
    y1: 0.509,
    x2: -1.026,
    y2: 0.509,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: -1.057,
    y1: 0.387,
    x2: -2.035,
    y2: 0.609,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: -1.534,
    y1: -0.07,
    x2: -0.961,
    y2: 0.593,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: -0.956,
    y1: -0.412,
    x2: -1.489,
    y2: 1.148,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: -1.047,
    y1: 0.446,
    x2: -0.042,
    y2: 0.446,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: -0.899,
    y1: 0.539,
    x2: 0.32,
    y2: 0.391,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2d2244"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3e2c5e",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: -2.396,
    y1: 0.027,
    x2: -1.74,
    y2: 0.85,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ce1d3b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ed202e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: -2.37,
    y1: -0.069,
    x2: -1.983,
    y2: 0.584,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: -1.065,
    y1: 0.477,
    x2: -0.294,
    y2: 0.421,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a193ad"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    stopColor: "#cec4d6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: -0.5,
    y1: 0.854,
    x2: -0.606,
    y2: -0.076,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: -1.31,
    y1: 0.922,
    x2: -0.776,
    y2: 0.22,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cec4d6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    stopColor: "#cec4d6",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: -5.957,
    y1: 0.822,
    x2: -6.31,
    y2: 0.073,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#34254c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#432a68"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: -5.948,
    y1: 0.835,
    x2: -6.299,
    y2: 0.095,
    xlinkHref: "#linear-gradient-18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: -10.927,
    y1: 1.188,
    x2: -11.227,
    y2: -0.239,
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: -9.691,
    y1: 0.851,
    x2: -8.803,
    y2: -0.101,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3492b7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4cc8e5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: -9.734,
    y1: 0.223,
    x2: -8.734,
    y2: 0.223,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d733db"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f43ef9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: -4.651,
    y1: 0.544,
    x2: -3.746,
    y2: 0.309,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1e45a5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2265c6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: -2.791,
    y1: 0.438,
    x2: -1.826,
    y2: 0.007,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: -0.997,
    y1: 0.411,
    x2: 0.008,
    y2: 0.411,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: -2.944,
    y1: 0.259,
    x2: -3.357,
    y2: 0.32,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    x1: -3.29,
    y1: 0.452,
    x2: -2.917,
    y2: 0.406,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    x1: -2.897,
    y1: -0.019,
    x2: -1.891,
    y2: -0.019,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-29",
    x1: -0.69,
    y1: 0.541,
    x2: 0.194,
    y2: 0.201,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-30",
    x1: -0.587,
    y1: 0.844,
    x2: -0.309,
    y2: -0.071,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c8b8d3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c8b8d3",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-31",
    x1: -0.743,
    y1: 0.732,
    x2: -0.196,
    y2: 0.412,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-32",
    x1: -0.914,
    y1: 0.544,
    x2: 0.255,
    y2: 0.286,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#201d21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#524b56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-33",
    x1: -1.339,
    y1: 0.455,
    x2: -0.655,
    y2: 0.414,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#111011"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#111011",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-34",
    x1: -1.492,
    y1: -0.362,
    x2: -1.155,
    y2: 1.191,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ede7f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ede7f2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-35",
    x1: -12.096,
    y1: -1.077,
    x2: -10.013,
    y2: 1.797,
    xlinkHref: "#linear-gradient-34"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-36",
    x1: -1.711,
    y1: 0.548,
    x2: -0.682,
    y2: 0.548,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-37",
    x1: -0.579,
    y1: 0.701,
    x2: -1.472,
    y2: -0.485,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-38",
    x1: -5.515,
    y1: 1.118,
    x2: -5.949,
    y2: 0.062,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-39",
    x1: -10.118,
    y1: 0.263,
    x2: -8.974,
    y2: 0.263,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-40",
    x1: -2.842,
    y1: 0.476,
    x2: -1.858,
    y2: 0.045,
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-41",
    x1: -0.201,
    y1: 0.699,
    x2: -0.873,
    y2: 0.141,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-42",
    x1: -5.698,
    y1: -0.3,
    x2: -4.726,
    y2: -0.3,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-43",
    x1: -5.541,
    y1: -0.389,
    x2: -4.546,
    y2: -0.389,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-44",
    x1: -3.773,
    y1: -0.26,
    x2: -2.802,
    y2: -0.26,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-45",
    x1: -3.158,
    y1: -0.46,
    x2: -2.177,
    y2: -0.46,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-46",
    x1: -7.338,
    y1: -0.853,
    x2: -8.482,
    y2: 0.572,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-47",
    x1: -1.421,
    y1: 0.618,
    x2: -2.538,
    y2: 0.344,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-48",
    x1: -5.041,
    y1: 0.444,
    x2: -4.852,
    y2: -0.585,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-49",
    x1: -8.096,
    y1: -0.734,
    x2: -7.073,
    y2: -0.734,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-50",
    x1: -6.486,
    y1: -0.636,
    x2: -5.483,
    y2: -0.636,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-51",
    x1: -8.174,
    y1: -0.61,
    x2: -7.171,
    y2: -0.61,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-52",
    x1: -6.756,
    y1: -0.696,
    x2: -5.76,
    y2: -0.696,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-53",
    x1: -23.383,
    y1: 1.44,
    x2: -24.02,
    y2: 0.859,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-54",
    x1: -144.987,
    y1: 3.609,
    x2: -143.934,
    y2: 3.609,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-55",
    x1: -131.774,
    y1: 4.02,
    x2: -130.76,
    y2: 4.02,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-56",
    x1: -94.675,
    y1: 3.14,
    x2: -93.622,
    y2: 3.14,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-57",
    x1: -76.116,
    y1: 3.644,
    x2: -75.073,
    y2: 3.644,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-58",
    x1: -144.093,
    y1: 1.323,
    x2: -144.973,
    y2: 2.807,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-59",
    x1: -45.51,
    y1: 1.36,
    x2: -46.359,
    y2: 1.071,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-60",
    x1: -121.133,
    y1: 4.375,
    x2: -120.947,
    y2: 3.351,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-61",
    x1: -177.79,
    y1: 5.788,
    x2: -176.824,
    y2: 5.788,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-62",
    x1: -149.283,
    y1: 4.957,
    x2: -148.29,
    y2: 4.957,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-63",
    x1: -182.864,
    y1: 4.73,
    x2: -181.881,
    y2: 4.73,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-64",
    x1: -152.976,
    y1: 5.115,
    x2: -151.967,
    y2: 5.115,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-65",
    x1: -1.106,
    y1: 0.529,
    x2: -0.029,
    y2: 0.529,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-66",
    x1: -1.156,
    y1: 0.912,
    x2: 0.052,
    y2: 0.301,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bbaec4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ded1e8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-67",
    x1: -25.061,
    y1: 17.134,
    x2: -24.413,
    y2: 17.134,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-68",
    x1: -0.54,
    y1: 0.452,
    x2: 0.337,
    y2: 0.277,
    xlinkHref: "#linear-gradient-66"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-69",
    x1: 0.656,
    y1: 0.307,
    x2: -0.124,
    y2: 0.715,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#04074a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-70",
    x1: 0.585,
    y1: 0.286,
    x2: -0.189,
    y2: 0.836,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#04074a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#04074a"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2405",
    "data-name": "Group 2405",
    transform: "translate(-166.992 -673.768)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2390",
    "data-name": "Group 2390",
    transform: "translate(166.992 673.768)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2389",
    "data-name": "Group 2389"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2385",
    "data-name": "Group 2385",
    transform: "translate(0 7.991)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2384",
    "data-name": "Group 2384"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7514",
    "data-name": "Path 7514",
    d: "M322.551,1018.563V949.7H166.992V901.529L317.473,677.8h61.934V901.529h38.708V949.7H379.407v68.859Zm1.938-117.034,3.386-166.385L221.426,901.529Z",
    transform: "translate(-166.992 -677.801)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2387",
    "data-name": "Group 2387",
    transform: "translate(573.159 7.991)",
    opacity: 0.94
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2386",
    "data-name": "Group 2386"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7515",
    "data-name": "Path 7515",
    d: "M611.827,1018.563V949.7H456.266V901.529L606.747,677.8h61.934V901.529h38.708V949.7H668.681v68.859Zm1.936-117.034,3.386-166.385L510.7,901.529Z",
    transform: "translate(-456.266 -677.801)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2388",
    "data-name": "Group 2388",
    transform: "translate(285.422)",
    opacity: 0.94
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7516",
    "data-name": "Path 7516",
    d: "M565.8,855.666q0,82.017-33.992,128.43t-93.5,46.416q-60.241,0-93.748-46.885T311.045,851.9q0-84.127,33.872-131.133t94.109-47q60.969,0,93.869,47.119T565.8,855.666ZM437.333,982.332q35.317,0,53.1-32.784t17.783-98.114q0-63.453-17.541-96.707t-51.169-33.253q-35.079,0-52.982,33.134t-17.9,97.765q0,62.746,17.783,96.352T437.333,982.332Z",
    transform: "translate(-311.045 -673.768)",
    fill: "#fff"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2404",
    "data-name": "Group 2404",
    transform: "translate(444.99 736.78)"
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2403",
    "data-name": "Group 2403"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7517",
    "data-name": "Path 7517",
    d: "M350.792,772.212s-5.308-16.152-3.586-18.462,25.171-12.5,55.1-18.861,31.347-3.947,33.658-2.225,5.122,20.008,5.066,23.769S350.792,772.212,350.792,772.212Z",
    transform: "translate(-268.471 -680.863)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7518",
    "data-name": "Path 7518",
    d: "M512.038,889.639l-2.079,4.579-14.513,32-13.9,30.648c-6.907-4.852-9.055-22.558-8.722-36.047a108.182,108.182,0,0,0-1.532-22.445c-4.141-1.989-7.591-5.556-10.186-9a52.584,52.584,0,0,1-4.1-6.372v0c-.884-1.611-1.351-2.663-1.351-2.663-16.231.793-27.283-9.728-29.9-11.428s-7.525-.113-12.413,10.87c-4.4,9.883-15.546,13.885-17.727,14.587-.242.077-.375.115-.375.115-.474,2.649-.971,5.042-1.488,7.206-4.145,17.5-9.2,19.829-9.2,19.829-.553,5.675,2.827,13.9,3.862,24.478s-.042,26.937-.042,26.937l-14.6-9.067L345.2,946.116s-10.826-25.57-10.154-34.072a24.385,24.385,0,0,1,1.446-6.453,30.128,30.128,0,0,1,2.762-5.605l.008-.012a23.8,23.8,0,0,1,1.975-2.758s-.04-1.359.026-3.491c.03-.951.081-2.057.164-3.265a64.415,64.415,0,0,1,1.24-9,20.425,20.425,0,0,1,.652-2.3,24.549,24.549,0,0,1,1.656-3.765,29.145,29.145,0,0,1,1.936-3.081v0l.006,0,.071-.1.048-.067.022-.026.022-.03.069-.1c.054-.071.105-.145.161-.214s.1-.141.159-.208c.188-.248.372-.485.555-.707a24.337,24.337,0,0,1,2.205-2.427l0,0,0,0s.644-2.233,1.516-5.439c.67-2.481,1.478-5.538,2.225-8.6,1.714-7.008,1.545-9.5,6.008-12.938,4.389-3.378,5.482-6.227,8.064-8.282l.012-.008.121-.1c1.5-1.157,4.248-2.889,6.366-4.188l.026-.012c1.647-1.014,2.911-1.757,2.911-1.757a28.324,28.324,0,0,1,1.565-9.19,12.177,12.177,0,0,1-1.25-2.962c-.42-1.335-.689-2.542-.689-2.542-.725.493-1.435.933-2.124,1.326l-.016.01c-7.567,4.3-12.922,2.823-12.922,2.823a29.4,29.4,0,0,1-5.982,1.815,27.359,27.359,0,0,1-7.654.365C335.8,817.6,327.034,808.3,327.034,808.3l6.588-9.334,14.545-20.608a17.229,17.229,0,0,1,5.8,2.083l.012.006a10.847,10.847,0,0,1,1.191.84l.01.008c.192.156.363.311.517.456a5.973,5.973,0,0,1,1.224,1.55l0,.006c.03.057.044.091.044.091a.061.061,0,0,1,.006-.026v0a12.68,12.68,0,0,1,.19-1.343,8.778,8.778,0,0,1,.848-2.485c.075-.141.153-.273.232-.4a5.539,5.539,0,0,1,1.341-1.5,3.973,3.973,0,0,1,1.635-.791c.044-.422.093-.832.151-1.234,2.074-15.187,11.858-15.558,11.858-15.558,2.039-11.413,13.616-11.577,13.616-11.577s2.451.577,6.313,1.118l.028,0c6.172.866,15.934,1.648,25.047-.129a34.658,34.658,0,0,0,19.233-10.69,21.487,21.487,0,0,0,2.092-2.667c9.558-2.217,16.955,9.806,16.955,9.806,5.478.018,9.861,3.656,12.378,6.384a23.721,23.721,0,0,1,2.352,2.946c.059-.079.125-.159.188-.236a14.933,14.933,0,0,1,2.049-2.1l.008-.01.024-.016a.248.248,0,0,1,.04-.034v0c.127-.1.254-.212.382-.311h0a19.257,19.257,0,0,1,3.543-2.209,21.379,21.379,0,0,1,5.518-1.833l12.891,26.673,2.79,5.77a19.975,19.975,0,0,1-10.555,12.911,23.706,23.706,0,0,1-2.582,1.139,15.968,15.968,0,0,1-2,.6c-7.242,1.676-15.2-1.553-19.727-3.909l0,0s-.061-.028-.174-.089c-.036-.02-.071-.04-.107-.056-.081-.044-.178-.1-.289-.162-1.952-1.044-3.127-1.851-3.127-1.851a23.514,23.514,0,0,1,1.074,3.874l0,0c.048.255.093.515.137.773a45.794,45.794,0,0,1,.226,11.85,38.288,38.288,0,0,1,2.227,9.053c.357,3.775-.5,5.35-.8,5.768-.046.065-.077.1-.089.119a6.159,6.159,0,0,1,.725-.384l.028-.016a13.8,13.8,0,0,1,2.54-.864c.166-.04.339-.077.515-.115l.069-.014a19.354,19.354,0,0,1,2.1-.3l0,0a27.022,27.022,0,0,1,11.161,1.643l.01,0c.115.042.234.081.353.127.222.077.446.161.674.248,11.9,4.514,16.955,23.586,16.955,23.586a20.747,20.747,0,0,1,5.278,5.566,35.414,35.414,0,0,1,6.249,16.511C510.628,878.148,512.038,889.639,512.038,889.639Z",
    transform: "translate(-287.93 -675.868)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7519",
    "data-name": "Path 7519",
    d: "M348.413,787.472c-12.617-1.143-21.379-10.44-21.379-10.44l6.588-9.334c2.249,2.879,7.121,8.06,14.113,9.8a20.55,20.55,0,0,0,6.57.578A32.233,32.233,0,0,1,348.413,787.472Z",
    transform: "translate(-287.93 -644.599)",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7520",
    "data-name": "Path 7520",
    d: "M446.695,788.763,436.758,803.8s-8.746,14.109-25.126,12.722-31.181-16.352-42.936-9.6-18.548,21.936-18.548,21.936l6.753-2.027s-11.87,7.84-14,12.805a2.27,2.27,0,0,0,.345,2.845l-7.159,2.094a29.145,29.145,0,0,1,1.936-3.081v0l.006,0,.071-.1.048-.067.022-.026.022-.03.069-.1c.054-.071.105-.145.161-.214s.1-.141.159-.208c.188-.248.372-.485.555-.707a24.337,24.337,0,0,1,2.205-2.427l0,0,0,0s.644-2.233,1.516-5.439c.67-2.481,1.478-5.538,2.225-8.6,1.714-7.008,1.545-9.5,6.008-12.938,4.389-3.378,5.482-6.227,8.064-8.282l.012-.008.121-.1c1.5-1.157,4.248-2.889,6.366-4.188l.026-.012c1.647-1.014,2.911-1.757,2.911-1.757a28.324,28.324,0,0,1,1.565-9.19,12.177,12.177,0,0,1-1.25-2.962c-.42-1.335-.689-2.542-.689-2.542-.725.493-1.435.933-2.124,1.326l-.016.01c-7.567,4.3-12.922,2.823-12.922,2.823a29.4,29.4,0,0,1-5.982,1.815,34.893,34.893,0,0,0,3.648-10.266,15.017,15.017,0,0,0,4.1-2.318s2.063,2.677,7.05,2.338,14.71-4.761,14.66-10.083a35.051,35.051,0,0,0,23.875,24.054C420.353,797.452,438.449,791.833,446.695,788.763Z",
    transform: "translate(-279.041 -645.055)",
    fill: "url(#linear-gradient-4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7521",
    "data-name": "Path 7521",
    d: "M362.144,843.737c-.553,5.675,2.827,13.9,3.862,24.478s-.042,26.937-.042,26.937l-14.6-9.067c3.4-9.283-1.013-23.3-1.466-33.683-.561-12.8,7.234-13.335,7.234-13.335a21.594,21.594,0,0,1,6.665-23.981,45.233,45.233,0,0,1,7.545,8.821C367.195,841.406,362.144,843.737,362.144,843.737Z",
    transform: "translate(-265.523 -598.094)",
    fill: "url(#linear-gradient-5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7522",
    "data-name": "Path 7522",
    d: "M431.423,808.525a51.564,51.564,0,0,0-6.134,14.345c-.884-1.611-1.351-2.663-1.351-2.663-16.231.793-27.283-9.728-29.9-11.428s-7.525-.113-12.413,10.87c-4.4,9.883-15.546,13.885-17.727,14.587-.927-1.195-2.487-3.137-4.539-5.4,3.832-3.794,7.032-9.205,12.3-17.589,6.78-10.8,15.4-12.98,19.725-13.874,6.794-1.4,9.9,2.77,25.393,9.544A24.154,24.154,0,0,0,431.423,808.525Z",
    transform: "translate(-256.213 -615.744)",
    fill: "url(#linear-gradient-6)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7523",
    "data-name": "Path 7523",
    d: "M429.041,860.813l-13.9,30.648c-6.907-4.852-9.055-22.558-8.722-36.047a108.182,108.182,0,0,0-1.532-22.445c-4.141-1.989-7.591-5.556-10.186-9a121.578,121.578,0,0,1,13.255-21.492c-2.223,9.043,2.16,16.043,7.333,22.265,0,0-1.559,13.887,1.139,25.916C418.183,858.479,424.7,860.415,429.041,860.813Z",
    transform: "translate(-221.524 -610.468)",
    fill: "url(#linear-gradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7524",
    "data-name": "Path 7524",
    d: "M436.079,847.44,434,852.019c-3.931-4.377-7.331-13.634-9.116-26.366-2.439-17.371-13.15-19.778-13.15-19.778,4.25-13.917-5.443-25.066-7.3-27.038.222.077.446.161.674.248,11.9,4.514,16.955,23.586,16.955,23.586a20.747,20.747,0,0,1,5.278,5.566,35.414,35.414,0,0,1,6.249,16.511C434.669,835.948,436.079,847.44,436.079,847.44Z",
    transform: "translate(-211.971 -633.668)",
    fill: "url(#linear-gradient-8)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7525",
    "data-name": "Path 7525",
    d: "M365.7,752.036c1.048,6.192,11.4,6.426,11.4,6.426-6.439,2.005-11.8,1.431-18.456.319s-11.165,10.783-9.362,11.553,3.525,3.878,3.525,3.878c-5.179-2.465-5.944.091-4.315,5.619s.957,14.028.957,14.028c-1.014-5.75-4.789-13.517-7.208-18.094a8.778,8.778,0,0,1,.848-2.485c.075-.141.153-.273.232-.4a5.539,5.539,0,0,1,1.341-1.5,3.973,3.973,0,0,1,1.635-.791c.044-.422.093-.832.151-1.234,2.074-15.187,11.858-15.558,11.858-15.558,2.039-11.413,13.616-11.577,13.616-11.577s2.451.577,6.313,1.118C373.488,742.719,364.653,745.856,365.7,752.036Z",
    transform: "translate(-273.007 -669.609)",
    fill: "url(#linear-gradient-9)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7526",
    "data-name": "Path 7526",
    d: "M416.733,755.009l-.24,1.179a21,21,0,0,0-16.584-6.073c-1.2,5.407-10.529,6.356-10.529,6.356s7.248-3.939,6.307-8.573-12.818-8.835-12.818-8.835c-.038-.093-.069-.192-.1-.287a21.487,21.487,0,0,0,2.092-2.667c9.558-2.217,16.955,9.806,16.955,9.806,5.478.018,9.861,3.656,12.378,6.384a23.721,23.721,0,0,1,2.352,2.946C416.6,755.166,416.669,755.087,416.733,755.009Z",
    transform: "translate(-233.234 -675.868)",
    fill: "url(#linear-gradient-10)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7527",
    "data-name": "Path 7527",
    d: "M344.28,809.6c-.222.533-7.313,17.608-12.467,23.6l0,.006a30.128,30.128,0,0,1,2.762-5.605l.008-.012a23.8,23.8,0,0,1,1.975-2.758s-.04-1.359.026-3.491c.03-.951.081-2.057.164-3.265C338.908,816.493,342.455,813.474,344.28,809.6Z",
    transform: "translate(-283.244 -603.482)",
    fill: "#cec4d6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7528",
    "data-name": "Path 7528",
    d: "M418.483,773.041a52.7,52.7,0,0,0,5.292,8.861c-7.242,1.676-15.2-1.553-19.727-3.909l0,0s-.061-.028-.174-.089c-.036-.02-.071-.04-.107-.056-.081-.044-.178-.1-.289-.162-1.952-1.044-3.127-1.851-3.127-1.851a23.514,23.514,0,0,1,1.074,3.874l0,0c.048.255.093.515.137.773-9.3-12.932-13.44-29.889-13.632-30.705.287.82,6.241,17.533,20.6,22.053A25.383,25.383,0,0,0,418.483,773.041Z",
    transform: "translate(-228.168 -662.186)",
    fill: "#e5dfe9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7529",
    "data-name": "Path 7529",
    d: "M421.356,761.456A19.975,19.975,0,0,1,410.8,774.366a49.593,49.593,0,0,1-4.981-8.153c7.024-2.392,11.169-7.987,12.746-10.527Z",
    transform: "translate(-210.611 -656.388)",
    fill: "#e5dfe9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2392",
    "data-name": "Group 2392",
    transform: "translate(99.316 139.201)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7530",
    "data-name": "Path 7530",
    d: "M436.357,780.448l0,.016s-13.307,7.464-15.445,9.855-4.028,6.047-14.2,9.166a69.693,69.693,0,0,1-8.633,2.043c-8.894,1.51-19.974,1.577-29.053-3.545a25.823,25.823,0,0,0-11.6-9.62,93.242,93.242,0,0,0,12.013,1.862c.388.024.767.042,1.129.048.606.016,1.173.008,1.69-.028a5.913,5.913,0,0,1,2.076-1.706c1.09-.448,3.868-.412,7.529-.442.47-.008.951-.012,1.448-.018,2.122-.032,4.478-.109,6.941-.313,2.174-.182,4.3-.434,6.218-.7.5-.065.987-.133,1.454-.2,3.428-.5,5.978-.971,6.606-1.015a5.262,5.262,0,0,1,3.594,1.361c.176.155.273.254.273.254s.345-.121.957-.341c1.145-.416,3.234-1.181,5.762-2.177.351-.137.713-.279,1.082-.428.731-.291,1.49-.6,2.271-.919.266-.109.527-.216.8-.329h0c1.926-.8,3.943-1.682,5.891-2.592.206-.095.416-.194.618-.293a55.862,55.862,0,0,0,8.177-4.563q.065.7.079,1.292c.075,2.851-.62,4.107-.88,4.476-.046.065-.077.1-.089.119a6.159,6.159,0,0,1,.725-.384l.028-.016A13.8,13.8,0,0,1,436.357,780.448Z",
    transform: "translate(-357.423 -775.825)",
    fill: "url(#linear-gradient-11)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7531",
    "data-name": "Path 7531",
    d: "M434.033,777.117c-3.263,2-15.09,8.99-24.587,11.375l-.161,4.177c.012-.442-.111-5.209-9.867-3.648a151.025,151.025,0,0,1-20.242,1.692s2.75,12.116,18.9,10.814c-8.894,1.51-19.974,1.577-29.053-3.545a25.823,25.823,0,0,0-11.6-9.62,93.242,93.242,0,0,0,12.013,1.862c.388.024.767.042,1.129.048.606.016,1.173.008,1.69-.028a5.913,5.913,0,0,1,2.076-1.706c1.09-.448,3.868-.412,7.529-.442.47-.008.951-.012,1.448-.018,2.122-.032,4.478-.109,6.941-.313,2.174-.182,4.3-.434,6.218-.7.5-.065.987-.133,1.454-.2,3.428-.5,5.978-.971,6.606-1.015a5.262,5.262,0,0,1,3.594,1.361c.176.155.273.254.273.254s.345-.121.957-.341c1.145-.416,3.234-1.181,5.762-2.177.351-.137.713-.279,1.082-.428.731-.291,1.49-.6,2.271-.919.266-.109.527-.216.8-.329h0c1.926-.8,3.943-1.682,5.891-2.592.206-.095.416-.194.618-.293a55.862,55.862,0,0,0,8.177-4.563Q434.019,776.521,434.033,777.117Z",
    transform: "translate(-357.423 -775.825)",
    fill: "url(#linear-gradient-12)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2391",
    "data-name": "Group 2391",
    transform: "translate(12.013 4.563)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7532",
    "data-name": "Path 7532",
    d: "M371.205,782.01l.02,13-1.468-12.982C370.227,782.02,370.708,782.016,371.205,782.01Z",
    transform: "translate(-357.332 -774.318)",
    fill: "#5c479e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7533",
    "data-name": "Path 7533",
    d: "M378.583,781.4l-.565,13.255-.89-13.053C377.628,781.535,378.116,781.467,378.583,781.4Z",
    transform: "translate(-350.097 -774.919)",
    fill: "#5c479e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7534",
    "data-name": "Path 7534",
    d: "M364.615,783.141l-.755,5.465-.374-5.512C363.874,783.117,364.253,783.135,364.615,783.141Z",
    transform: "translate(-363.486 -773.255)",
    fill: "#5c479e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7535",
    "data-name": "Path 7535",
    d: "M383.611,791.244c-.036-3.769-.4-7.668-.6-9.628.176.155.273.254.273.254s.345-.121.957-.341A38.985,38.985,0,0,1,383.611,791.244Z",
    transform: "translate(-344.325 -774.79)",
    fill: "#5c479e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7536",
    "data-name": "Path 7536",
    d: "M387.622,780.214l-.561,8.09-.521-7.662C386.891,780.505,387.253,780.363,387.622,780.214Z",
    transform: "translate(-340.861 -776.081)",
    fill: "#5c479e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7537",
    "data-name": "Path 7537",
    d: "M389.031,779.584l-.412,5.988-.386-5.659C388.5,779.8,388.759,779.7,389.031,779.584Z",
    transform: "translate(-339.201 -776.699)",
    fill: "#5c479e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7538",
    "data-name": "Path 7538",
    d: "M392.227,778.128l-.321,4.664-.3-4.371C391.815,778.326,392.025,778.227,392.227,778.128Z",
    transform: "translate(-335.887 -778.128)",
    fill: "#5c479e"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2393",
    "data-name": "Group 2393",
    transform: "translate(51.335 76.431)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7539",
    "data-name": "Path 7539",
    d: "M388.24,796.539c-6.752,2.027-14.716-13.717-27.789-12.512a43.42,43.42,0,0,0-12.711,3.776l.121-.1c1.5-1.157,4.248-2.889,6.366-4.188l.026-.012c.339-.156,4.044-1.785,11.393-1.4C375.072,782.6,381.609,795.738,388.24,796.539Z",
    transform: "translate(-318.944 -706.949)",
    fill: "#aca5b5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7540",
    "data-name": "Path 7540",
    d: "M421.979,779.622c-18.385-2.31-35.792,16.041-35.792,16.041,7.579-9.792,14.252-14.163,18.736-16.112.22-.1.43-.182.636-.266l.028-.016a21.366,21.366,0,0,1,3.055-.979l.069-.014a9.8,9.8,0,0,1,2.1-.3l0,0A27.022,27.022,0,0,1,421.979,779.622Z",
    transform: "translate(-281.213 -711.013)",
    fill: "#aca5b5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7541",
    "data-name": "Path 7541",
    d: "M337.068,804.715l.006,0-.006.006Z",
    transform: "translate(-329.418 -684.707)",
    fill: "#aca5b5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7542",
    "data-name": "Path 7542",
    d: "M355.894,797.316a48.782,48.782,0,0,0-18.787,14.551,27.14,27.14,0,0,1,3.245-3.786s.644-2.233,1.516-5.439A72.886,72.886,0,0,1,355.894,797.316Z",
    transform: "translate(-329.38 -691.965)",
    fill: "#aca5b5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7543",
    "data-name": "Path 7543",
    d: "M339.056,813.518a35.783,35.783,0,0,1-5.849,10.222,23.8,23.8,0,0,1,1.975-2.758s-.04-1.359.026-3.491A13.078,13.078,0,0,0,339.056,813.518Z",
    transform: "translate(-333.207 -676.065)",
    fill: "#aca5b5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7544",
    "data-name": "Path 7544",
    d: "M404.121,744.755c-.711.65-6.606,6.6-4.8,24.434,0,0-3.769-13.356.212-25.044a23.721,23.721,0,0,1,2.352,2.946A14.946,14.946,0,0,1,404.121,744.755Z",
    transform: "translate(-269.909 -744.145)",
    fill: "#c0b8cc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7545",
    "data-name": "Path 7545",
    d: "M400.972,744.44l-.024.016.012-.01Z",
    transform: "translate(-266.728 -743.856)",
    fill: "#aca5b5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7546",
    "data-name": "Path 7546",
    d: "M342.981,760.784a13.607,13.607,0,0,0-1.742-2.005A6.605,6.605,0,0,1,342.981,760.784Z",
    transform: "translate(-325.325 -729.784)",
    fill: "#aca5b5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7547",
    "data-name": "Path 7547",
    d: "M349.542,778.471c-2.853-9.19-5.49-14.121-7.4-16.746v0a9.914,9.914,0,0,1,1.038-3.828C347.993,766.779,349.542,778.471,349.542,778.471Z",
    transform: "translate(-324.436 -730.653)",
    fill: "#aca5b5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7548",
    "data-name": "Path 7548",
    d: "M351.544,759.836a8.266,8.266,0,0,0-8.082-1.9,3.973,3.973,0,0,1,1.635-.791c.044-.422.093-.832.151-1.234A9.986,9.986,0,0,1,351.544,759.836Z",
    transform: "translate(-323.143 -732.6)",
    fill: "#aca5b5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7549",
    "data-name": "Path 7549",
    d: "M360.978,771.339a78.22,78.22,0,0,1-7.961,8.764c-.42-1.335-.689-2.542-.689-2.542C351.6,778.054,360.978,771.339,360.978,771.339Z",
    transform: "translate(-314.482 -717.458)",
    fill: "#aca5b5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7550",
    "data-name": "Path 7550",
    d: "M396.464,766.1a23.514,23.514,0,0,1,1.074,3.874,29.489,29.489,0,0,1-5.649-10.287,20.339,20.339,0,0,0,7.7,8.264C397.639,766.911,396.464,766.1,396.464,766.1Z",
    transform: "translate(-275.618 -728.889)",
    fill: "#aca5b5"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_7551",
    "data-name": "Path 7551",
    d: "M372.621,775.044l2.964,4.417c-4.755,3.771-13.186,8.73-17.84,9.36s-7.523-.113-8.027-2.9c-.382-2.116,3.368-5.746,5.187-7.363.573-.509.957-.82.957-.82l.953,2.061s-5.494,5.669-1.8,6.34a3.513,3.513,0,0,0,.382.052c4.43.357,17.054-11.53,17.054-11.53",
    transform: "translate(-265.694 -637.763)",
    fill: "#34254c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7552",
    "data-name": "Path 7552",
    d: "M353.984,784.618l0,0s-3.38.273-3.238-2.241c.077-1.377,1.688-3.6,3.133-5.344.573-.509.957-.82.957-.82l.953,2.061S350.292,783.946,353.984,784.618Z",
    transform: "translate(-264.665 -636.239)",
    fill: "#51347f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7553",
    "data-name": "Path 7553",
    d: "M411.956,776.846a13.8,13.8,0,0,1-4.775,3.905c-5.978,3.364-18.124.608-18.124.608l-1.381-6.481s7.8,4.165,15.593,3.634a14.94,14.94,0,0,0,4.161-.8c2.677-1,3.17-2.645,2.421-3.723-1.042-1.494-7.755-.315-7.755-.315l.16-5.431a29.927,29.927,0,0,1,5.867.957,6.688,6.688,0,0,1,3.739,2.148A4.562,4.562,0,0,1,411.956,776.846Z",
    transform: "translate(-228.417 -644.063)",
    fill: "#34254c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7554",
    "data-name": "Path 7554",
    d: "M402.171,776.372a6.627,6.627,0,0,1-4.525.868c5.1-1.528,2.027-6.641.693-8.512a6.688,6.688,0,0,1,3.739,2.148A4.562,4.562,0,0,1,402.171,776.372Z",
    transform: "translate(-218.633 -643.589)",
    fill: "#51347f"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2394",
    "data-name": "Group 2394",
    transform: "translate(81.676 48.538)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7555",
    "data-name": "Path 7555",
    d: "M362.088,740.668s-9.239,4.137-8.147,24.733,18.11,31.337,18.11,31.337l.3,4.363s-13.121-4.115-20.525-20.836-1.617-37.472,10-41.71Z",
    transform: "translate(-348.52 -721.736)",
    fill: "url(#linear-gradient-13)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7556",
    "data-name": "Path 7556",
    d: "M383.6,734.911s11.868,4.516,17.048,20.761S396.576,783.2,387.359,790.4l2.982,7s16.239-9.877,17.876-27.214-10.424-33.426-22.467-40.121Z",
    transform: "translate(-314.092 -730.067)",
    fill: "url(#linear-gradient-14)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7557",
    "data-name": "Path 7557",
    d: "M418.179,798.292c-.063.935-8.237,2.356-11.407,2.938a352.368,352.368,0,0,1-39.225,4.9,1.046,1.046,0,0,1-1.068-.725,182.866,182.866,0,0,1-6.955-31.956q-.615-4.833-1-9.725a2.152,2.152,0,0,1,1.559-2.239c17.291-4.874,34.462-7.668,51.476-7.654a2.157,2.157,0,0,1,2.1,1.686C416.464,767.993,418.647,791.369,418.179,798.292Z",
    transform: "translate(-338.713 -706.747)",
    fill: "url(#linear-gradient-15)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7558",
    "data-name": "Path 7558",
    d: "M417.924,796.886c-.063.935-8.237,2.358-11.407,2.94a352.389,352.389,0,0,1-39.223,4.9,1.046,1.046,0,0,1-1.07-.727,182.779,182.779,0,0,1-6.955-31.955q-.615-4.83-1-9.725a2.149,2.149,0,0,1,1.557-2.237c17.291-4.876,34.462-7.67,51.476-7.656a2.161,2.161,0,0,1,2.1,1.688C416.209,766.589,418.392,789.965,417.924,796.886Z",
    transform: "translate(-338.961 -708.126)",
    fill: "url(#linear-gradient-16)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7559",
    "data-name": "Path 7559",
    d: "M406.018,790.11a352.17,352.17,0,0,1-38.686,4.86,1.724,1.724,0,0,1-1.767-1.2,183.013,183.013,0,0,1-6.794-31.442C365.56,774.08,380.523,792.79,406.018,790.11Z",
    transform: "translate(-338.461 -698.41)",
    fill: "url(#linear-gradient-17)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7560",
    "data-name": "Path 7560",
    d: "M361.958,761.354s2.814,18.286,5.718,28.738l3.721-.569s-3.125-18.264-3.891-29.487Z",
    transform: "translate(-335.333 -700.656)",
    fill: "url(#linear-gradient-18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7561",
    "data-name": "Path 7561",
    d: "M369.593,759.573s2.608,19.867,5.136,29.4l4.343-.61s-3.144-18.577-3.911-29.8Z",
    transform: "translate(-327.84 -702.099)",
    fill: "url(#linear-gradient-19)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7562",
    "data-name": "Path 7562",
    d: "M366.249,761.322s.781,6.836,1.722,11.47l3.721-.567-1.722-11.47A23.426,23.426,0,0,0,366.249,761.322Z",
    transform: "translate(-331.122 -699.951)",
    fill: "url(#linear-gradient-20)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7563",
    "data-name": "Path 7563",
    d: "M385.413,761.864a3.281,3.281,0,1,1-3.5-3.049A3.281,3.281,0,0,1,385.413,761.864Z",
    transform: "translate(-318.746 -701.862)",
    fill: "url(#linear-gradient-21)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7564",
    "data-name": "Path 7564",
    d: "M386.525,768.9a3.281,3.281,0,1,1-3.5-3.051A3.28,3.28,0,0,1,386.525,768.9Z",
    transform: "translate(-317.655 -694.956)",
    fill: "url(#linear-gradient-22)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_7565",
    "data-name": "Path 7565",
    d: "M393.274,750.028a6.719,6.719,0,1,1-7.161-6.245A6.718,6.718,0,0,1,393.274,750.028Z",
    transform: "translate(-236.096 -668.085)",
    fill: "url(#linear-gradient-23)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7566",
    "data-name": "Path 7566",
    d: "M359.407,761.8c3.067-.711,10.525-2.215,18.666-3.986a2,2,0,0,0,1.579-2.649l-1.551-5.124a1.586,1.586,0,0,0-1.811-1.242c-3.675.6-13.21,1.234-19.091,3.2-.743.248-1.538.418-1.1,2.823a43.848,43.848,0,0,0,1.442,5.934A1.588,1.588,0,0,0,359.407,761.8Z",
    transform: "translate(-259.528 -663.173)",
    fill: "url(#linear-gradient-24)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2395",
    "data-name": "Group 2395",
    transform: "translate(75.54)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7567",
    "data-name": "Path 7567",
    d: "M355.368,748.01s1.466,4.973,3.2,7.361c0,0,32.009,14.729,56.949-14.531,0,0-1.716-6.774-3.8-9.764C411.714,731.075,396.739,755.773,355.368,748.01Z",
    transform: "translate(-335.663 -680.54)",
    fill: "url(#linear-gradient-25)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7568",
    "data-name": "Path 7568",
    d: "M352.97,724.74s-6.325,3.576-7.228,4.25c-1.962,1.468,5.653,22.813,8.453,22.912,1.682.059,7.375-1.989,7.375-1.989Z",
    transform: "translate(-345.423 -686.757)",
    fill: "url(#linear-gradient-26)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7569",
    "data-name": "Path 7569",
    d: "M349.425,728.549a1.25,1.25,0,1,1-1.333-1.161A1.252,1.252,0,0,1,349.425,728.549Z",
    transform: "translate(-343.947 -684.162)",
    fill: "#c8b8d3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7570",
    "data-name": "Path 7570",
    d: "M381.685,714.846s7.208-.913,8.336-.911c2.449,0,9.106,21.668,6.919,23.422-1.312,1.052-7.1,2.812-7.1,2.812Z",
    transform: "translate(-309.837 -697.361)",
    fill: "url(#linear-gradient-27)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7571",
    "data-name": "Path 7571",
    d: "M384.552,717.318a1.251,1.251,0,1,0,.374-1.728A1.251,1.251,0,0,0,384.552,717.318Z",
    transform: "translate(-307.218 -695.933)",
    fill: "#c8b8d3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7572",
    "data-name": "Path 7572",
    d: "M357.9,713.727l-.769-2.56c4.716-3.676,10.7-5.455,17.783-5.6l1.48,3.343Z",
    transform: "translate(-333.937 -705.57)",
    fill: "url(#linear-gradient-28)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7573",
    "data-name": "Path 7573",
    d: "M422.893,751.247,407.23,756.3l-47.159,15.2c-18.258-19.738-13.9-51.963,10.194-61.767q1.673-.684,3.339-1.2l.014-.008C400.137,700.189,425.041,721.047,422.893,751.247Z",
    transform: "translate(-342.089 -704.481)",
    fill: "url(#linear-gradient-29)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7574",
    "data-name": "Path 7574",
    d: "M407.23,755.38l-47.159,15.2c-18.258-19.738-13.9-51.963,10.194-61.767q1.673-.684,3.339-1.2c-16.136,6.7-17.569,17.517-3.154,13.089s24.771-1.633,24.771-1.633Z",
    transform: "translate(-342.089 -703.561)",
    fill: "url(#linear-gradient-30)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7575",
    "data-name": "Path 7575",
    d: "M417.32,729.173a38.626,38.626,0,0,1-28.353,25.11C366.153,759.6,354.5,749.43,354.5,749.43Z",
    transform: "translate(-336.516 -682.407)",
    fill: "url(#linear-gradient-31)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7576",
    "data-name": "Path 7576",
    d: "M419.811,745.007a47.686,47.686,0,0,1-13.614,13.86c-10.111,6.925-26.166,12.637-49.207,6.4-10.022-18.831-4.222-37.884,9.937-46.948a33.1,33.1,0,0,1,3.333-1.875C387.745,707.9,413.988,714.712,419.811,745.007Z",
    transform: "translate(-339.007 -698.241)",
    fill: "url(#linear-gradient-32)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7577",
    "data-name": "Path 7577",
    d: "M406.2,756.253c-10.111,6.925-26.166,12.637-49.207,6.4-10.022-18.831-4.222-37.884,9.937-46.948-1.809,4.442-4.187,13.37-2.215,27,2.962,20.468,17.129,26.586,41.468,13.554Z",
    transform: "translate(-339.007 -695.627)",
    fill: "url(#linear-gradient-33)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7578",
    "data-name": "Path 7578",
    d: "M366.095,714.859s19.52-3.335,30.418,14.622a3.193,3.193,0,0,1-.872,4.268h0a3.184,3.184,0,0,1-4.613-1.026A36.892,36.892,0,0,0,366.095,714.859Z",
    transform: "translate(-325.136 -696.694)",
    fill: "url(#linear-gradient-34)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7579",
    "data-name": "Path 7579",
    d: "M385.39,726.957a2.5,2.5,0,1,1-3.414-.923A2.5,2.5,0,0,1,385.39,726.957Z",
    transform: "translate(-310.782 -685.814)",
    fill: "url(#linear-gradient-35)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2396",
    "data-name": "Group 2396",
    transform: "translate(55.393 74.458)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7580",
    "data-name": "Path 7580",
    d: "M414.056,800c-1.076,2.055-2.615,3-4.07,4.912v0A121.578,121.578,0,0,0,396.73,826.4a52.584,52.584,0,0,1-4.1-6.372v0a51.564,51.564,0,0,1,6.134-14.345A56.543,56.543,0,0,0,414.056,800Z",
    transform: "translate(-278.948 -687.36)",
    fill: "#2d2244"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7581",
    "data-name": "Path 7581",
    d: "M435.887,796.432c-4.2.624-11.036,2.493-19.079,7.9a46.625,46.625,0,0,0-9.861,9.536c1.165-1.583,2.413-2.191,3.487-4.246a59.465,59.465,0,0,1-14.708,5.021,58.9,58.9,0,0,1,5.891-8.023c10.749-12.32,28.991-15.756,28.991-15.756A20.747,20.747,0,0,1,435.887,796.432Z",
    transform: "translate(-275.91 -696.321)",
    fill: "url(#linear-gradient-36)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7582",
    "data-name": "Path 7582",
    d: "M366.3,818.518c-.242.077-.375.115-.375.115-.474,2.649-.971,5.042-1.488,7.206a45.233,45.233,0,0,0-7.545-8.821c.446-.363.9-.693,1.339-.993a24.3,24.3,0,0,0,3.529-2.909C363.817,815.382,365.376,817.323,366.3,818.518Z",
    transform: "translate(-314.017 -674.485)",
    fill: "#2d2244"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7583",
    "data-name": "Path 7583",
    d: "M383,822.337a24.3,24.3,0,0,1-3.529,2.909c-.444.3-.894.63-1.339.993a65.52,65.52,0,0,0-12.35-8.829c-13.041-7.329-24.617-6.245-30.529-4.874a24.549,24.549,0,0,1,1.656-3.765,29.145,29.145,0,0,1,1.936-3.081v0l.006,0,.071-.1.048-.067.022-.026.022-.03.069-.1c.054-.071.105-.145.161-.214s.1-.141.159-.208c.188-.248.372-.485.555-.707,1.09-.159,2.358-.305,3.767-.4a41.7,41.7,0,0,1,20.111,3.376C371.56,810.777,378.473,817.34,383,822.337Z",
    transform: "translate(-335.255 -683.704)",
    fill: "url(#linear-gradient-37)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7584",
    "data-name": "Path 7584",
    d: "M413.225,769.152a23.706,23.706,0,0,1-2.582,1.139,15.968,15.968,0,0,1-2,.6,52.7,52.7,0,0,1-5.292-8.861,20.914,20.914,0,0,0,4.894-1.03A49.593,49.593,0,0,0,413.225,769.152Z",
    transform: "translate(-268.429 -725.631)",
    fill: "#2d2244"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7585",
    "data-name": "Path 7585",
    d: "M410.813,778.516a20.914,20.914,0,0,1-4.894,1.03c-6.566-13.953-5.465-27.591-4.313-34.189h0a19.257,19.257,0,0,1,3.543-2.209c-1.238,6.832-.8,19.273,3.3,29.95C409.218,775.1,410.016,776.9,410.813,778.516Z",
    transform: "translate(-270.997 -743.149)",
    fill: "url(#linear-gradient-38)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7586",
    "data-name": "Path 7586",
    d: "M349.126,772.313a34.893,34.893,0,0,1-3.648,10.266,27.359,27.359,0,0,1-7.654.365,32.233,32.233,0,0,0,5.893-9.394A18.6,18.6,0,0,0,349.126,772.313Z",
    transform: "translate(-332.734 -714.528)",
    fill: "#2d2244"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7587",
    "data-name": "Path 7587",
    d: "M346.207,786.663A18.6,18.6,0,0,1,340.8,787.9c4.587-11.167,2.506-23,1.391-27.6a5.973,5.973,0,0,1,1.224,1.55l0,.006c.03.057.044.091.044.091a.061.061,0,0,1,.006-.026v0a9.914,9.914,0,0,1,1.038-3.828c.075-.141.153-.273.232-.4C347.814,770.4,347.558,779.9,346.207,786.663Z",
    transform: "translate(-329.815 -728.879)",
    fill: "url(#linear-gradient-39)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_7588",
    "data-name": "Path 7588",
    d: "M359.47,761.155c3.067-.711,10.866-2.487,18.666-3.987a1.588,1.588,0,0,0,1.254-1.882l-1.226-5.891a1.584,1.584,0,0,0-1.809-1.242c-3.675.6-13.255,2.283-19.136,4.248a1.586,1.586,0,0,0-1.056,1.775,42.317,42.317,0,0,0,1.442,5.934A1.588,1.588,0,0,0,359.47,761.155Z",
    transform: "translate(-259.366 -663.801)",
    fill: "url(#linear-gradient-40)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2397",
    "data-name": "Group 2397",
    transform: "translate(8.82 66.669)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7589",
    "data-name": "Path 7589",
    d: "M353.171,802.969a24.727,24.727,0,0,1-8.908,1.72,23.817,23.817,0,0,1-10.547-2.271,2.957,2.957,0,0,1-1.219,1.1l-.018.01c-1.234.692-3.61,1.351-8.03.777-7.9-1.028-10.691-5.221-10.592-8.361a2.578,2.578,0,0,1,1.345-2.08l.01,0c1.979-1.276,5.6-1.524,7.161-1.629,2.182-.149,2.764-.816,1.722-2.31a1.3,1.3,0,0,0-.184-.21c-1.318-1.288-5.685-1.347-8.155-2.667-2.6-1.389-4.08-4.732-4-8.183.04-1.7,1.571-2.665,3.618-2.978a12.926,12.926,0,0,1,6.9,1.009c4.2,1.906,5.718,1.177,5.881-1.026.117-1.561-3.113-3.685-6.071-5.718a38.532,38.532,0,0,1-3.253-2.415c-3-2.615-1.175-8.064,4.082-9.049a4.115,4.115,0,0,1,1.549,0l0,0c4.105.795,5.857,7.856,8.31,6.849,2.74-1.125.7-3.491-3.006-7.311-.485-.5-.985-1.046-1.472-1.625-3.23-3.826-6.037-9.037-2.413-11.734a3.725,3.725,0,0,1,3-.58c4.6.83,11.139,7.753,14.977,16.267a38.877,38.877,0,0,0,3.309,6.2c1.444,2.045,2.116,1.783,2.38,1.474a.8.8,0,0,0,.143-.242c1-1.478,1.6-10.916,2.136-16.9.087-.971.2-1.912.341-2.807.743-4.632,2.29-8.122,5.13-8.841a6.122,6.122,0,0,1,1.4-.206c2.465-.042,3.774,1.942,4.365,6.7a18.652,18.652,0,0,1,.1,3.4c-.244,4.058-1.6,7.674-1.532,12.358.093,5.944,3.656,12.277,4.811,20.028S363.849,798.8,353.171,802.969Z",
    transform: "translate(-311.75 -739.218)",
    fill: "url(#linear-gradient-41)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7590",
    "data-name": "Path 7590",
    d: "M328.589,750.715c-.4,3.359-4.05,3.618-6.453,3.412-.355-.418-.7-.852-1.034-1.3-2.732-3.634-4.607-8.032-1.379-10.436a3.725,3.725,0,0,1,3-.58c.991,1.213,3.01,2.744,4.4,4.589A6,6,0,0,1,328.589,750.715Z",
    transform: "translate(-305.596 -736.755)",
    fill: "url(#linear-gradient-42)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7591",
    "data-name": "Path 7591",
    d: "M325.613,756.221c-.622,2.074-2.623,5.07-6.327,4.321-1.018-.7-2.005-1.393-2.812-2.045-.155-.125-.3-.25-.442-.371-3-2.615-1.175-8.064,4.082-9.049a4.115,4.115,0,0,1,1.549,0l0,0a24.989,24.989,0,0,1,3.047,3.911l.006.006A4.513,4.513,0,0,1,325.613,756.221Z",
    transform: "translate(-308.961 -729.615)",
    fill: "url(#linear-gradient-43)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7592",
    "data-name": "Path 7592",
    d: "M325.654,771.653a5.519,5.519,0,0,1-1.744-.1c-1.056-.258-2.015-.483-2.909-.719a23.258,23.258,0,0,1-5.247-1.948c-2.6-1.389-4.08-4.732-4-8.183.04-1.7,1.571-2.665,3.618-2.978a22.939,22.939,0,0,0,5.841,3.9c.571.208,1.173.452,1.767.725,2.417,1.1,4.787,2.645,5.14,4.127C328.558,768.324,328.438,771.15,325.654,771.653Z",
    transform: "translate(-311.75 -721.058)",
    fill: "url(#linear-gradient-44)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7593",
    "data-name": "Path 7593",
    d: "M331.455,776.59l-.018.01c-1.125.632-3.2,1.236-6.913.9-.357-.034-.729-.073-1.117-.125-7.9-1.028-10.691-5.221-10.592-8.361a2.578,2.578,0,0,1,1.345-2.08l.01,0c.188-.077,3.35-1.25,10.846,1.878.224.093.444.188.66.279C332.86,772.168,334.607,774.32,331.455,776.59Z",
    transform: "translate(-310.707 -712.292)",
    fill: "url(#linear-gradient-45)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7594",
    "data-name": "Path 7594",
    d: "M329.359,775.041c-.2-.384-6.166-11.922,2.645-21.932,1.444,2.045,2.116,1.783,2.38,1.474l.186.38S326.3,766.794,329.359,775.041Z",
    transform: "translate(-296.588 -725.585)",
    fill: "url(#linear-gradient-46)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7595",
    "data-name": "Path 7595",
    d: "M337.067,802.969a24.727,24.727,0,0,1-8.908,1.72c19.2-4.379,16.774-22.354,14.48-27.937-2.627-6.4-3.245-15.439.192-24.755,2.522-6.846.834-11.036-.24-12.778,2.465-.042,3.774,1.942,4.365,6.7a18.652,18.652,0,0,1,.1,3.4c-.244,4.058-1.6,7.674-1.532,12.358.093,5.944,3.656,12.277,4.811,20.028S347.745,798.8,337.067,802.969Z",
    transform: "translate(-295.646 -739.218)",
    fill: "url(#linear-gradient-47)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7596",
    "data-name": "Path 7596",
    d: "M343.144,749.321a11.091,11.091,0,0,1-11-1.056c.743-4.632,2.29-8.122,5.13-8.841,3.386-.858,5.072.907,5.766,6.5A18.652,18.652,0,0,1,343.144,749.321Z",
    transform: "translate(-291.732 -739.217)",
    fill: "url(#linear-gradient-48)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7597",
    "data-name": "Path 7597",
    d: "M327.063,748.42c-.4,3.359-6.7,5-7.488,2.114.632-6.208,4.149-6.649,6.029-6.427A6,6,0,0,1,327.063,748.42Z",
    transform: "translate(-304.07 -734.461)",
    fill: "url(#linear-gradient-49)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7598",
    "data-name": "Path 7598",
    d: "M324.857,754.994c-.139,4.995-7.287,5.665-9.138,2.277a5.131,5.131,0,0,1,.8-5.154c3.109-3.891,7.27-.505,7.442-.36l.006.006A6,6,0,0,1,324.857,754.994Z",
    transform: "translate(-308.204 -728.388)",
    fill: "url(#linear-gradient-50)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7599",
    "data-name": "Path 7599",
    d: "M321.267,769.362a5.519,5.519,0,0,1-1.744-.1c-1.056-.258-2.015-.483-2.909-.719a8.431,8.431,0,0,1,1.977-8.484c2.417,1.1,4.787,2.645,5.14,4.127C324.172,766.034,324.051,768.859,321.267,769.362Z",
    transform: "translate(-307.363 -718.768)",
    fill: "url(#linear-gradient-51)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7600",
    "data-name": "Path 7600",
    d: "M326.166,775.384l-.018.01c-1.125.632-3.2,1.236-6.913.9a6.6,6.6,0,0,1-.834-5.156,5.809,5.809,0,0,1,1.985-3.255C327.571,770.961,329.319,773.113,326.166,775.384Z",
    transform: "translate(-305.419 -711.085)",
    fill: "url(#linear-gradient-52)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2398",
    "data-name": "Group 2398",
    transform: "translate(186.9 46.265)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7601",
    "data-name": "Path 7601",
    d: "M422.008,791.43a24.769,24.769,0,0,0,9.073.032,23.8,23.8,0,0,0,9.94-4.193,2.919,2.919,0,0,0,1.4.852l.02.008c1.341.45,3.8.656,8.036-.731,7.571-2.479,9.532-7.119,8.853-10.184a2.577,2.577,0,0,0-1.71-1.793l-.01,0c-2.183-.886-5.788-.454-7.339-.27-2.172.26-2.867-.285-2.122-1.948a1.388,1.388,0,0,1,.143-.242c1.056-1.51,5.336-2.38,7.517-4.135,2.3-1.849,3.131-5.409,2.411-8.785-.357-1.662-2.041-2.328-4.107-2.253a12.907,12.907,0,0,0-6.59,2.273c-3.772,2.653-5.4,2.219-5.968.083-.4-1.512,2.374-4.2,4.9-6.746a38.071,38.071,0,0,0,2.746-2.978c2.459-3.127-.343-8.141-5.693-8.131a4.147,4.147,0,0,0-1.524.283h0c-3.888,1.543-4.294,8.809-6.891,8.276-2.9-.6-1.339-3.3,1.593-7.743.382-.584.773-1.213,1.145-1.87,2.461-4.361,4.25-10,.188-11.977a3.72,3.72,0,0,0-3.059-.012c-4.365,1.668-9.5,9.689-11.692,18.768a39.011,39.011,0,0,1-2.1,6.707c-1.04,2.277-1.75,2.144-2.065,1.89a.759.759,0,0,1-.186-.212c-1.252-1.266-3.606-10.424-5.241-16.208-.268-.937-.551-1.843-.858-2.7-1.591-4.412-3.761-7.553-6.683-7.731a6.142,6.142,0,0,0-1.415.059c-2.431.416-3.349,2.607-3.043,7.4a18.546,18.546,0,0,0,.533,3.36c.995,3.939,3,7.24,3.8,11.855,1.014,5.859-1.31,12.744-1,20.574S410.742,789.314,422.008,791.43Z",
    transform: "translate(-401.626 -728.92)",
    fill: "url(#linear-gradient-53)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7602",
    "data-name": "Path 7602",
    d: "M416.483,739.078c1.014,3.228,4.652,2.8,6.976,2.154.27-.477.529-.967.775-1.468,2.007-4.08,3.032-8.75-.586-10.509a3.72,3.72,0,0,0-3.059-.012c-.749,1.375-2.447,3.255-3.473,5.326A5.991,5.991,0,0,0,416.483,739.078Z",
    transform: "translate(-387.253 -728.92)",
    fill: "url(#linear-gradient-54)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7603",
    "data-name": "Path 7603",
    d: "M420.819,743.706c1,1.922,3.521,4.494,7.02,3.069.87-.878,1.712-1.74,2.382-2.532.129-.151.25-.3.365-.446,2.459-3.127-.343-8.141-5.693-8.131a4.147,4.147,0,0,0-1.524.283h0a25.114,25.114,0,0,0-2.269,4.408l0,.008A4.517,4.517,0,0,0,420.819,743.706Z",
    transform: "translate(-383.008 -722.3)",
    fill: "url(#linear-gradient-55)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7604",
    "data-name": "Path 7604",
    d: "M426.006,759.091a5.527,5.527,0,0,0,1.692-.426c.991-.448,1.89-.848,2.724-1.246a23.343,23.343,0,0,0,4.793-2.889c2.3-1.849,3.131-5.409,2.411-8.785-.357-1.662-2.041-2.328-4.107-2.253a22.972,22.972,0,0,1-5.015,4.916c-.523.311-1.07.664-1.6,1.042-2.172,1.528-4.212,3.489-4.282,5.011C422.533,756.359,423.177,759.115,426.006,759.091Z",
    transform: "translate(-381.032 -714.626)",
    fill: "url(#linear-gradient-56)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7605",
    "data-name": "Path 7605",
    d: "M423.159,765.112l.02.008c1.222.41,3.376.618,6.961-.4.345-.1.7-.208,1.076-.331,7.571-2.479,9.532-7.119,8.853-10.184a2.577,2.577,0,0,0-1.71-1.793l-.01,0c-.2-.04-3.525-.6-10.307,3.862-.2.135-.4.27-.6.4C420.956,761.03,419.641,763.469,423.159,765.112Z",
    transform: "translate(-382.364 -705.911)",
    fill: "url(#linear-gradient-57)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7606",
    "data-name": "Path 7606",
    d: "M419.246,763c.127-.416,3.842-12.861-6.675-21.058-1.04,2.277-1.75,2.144-2.065,1.89l-.113.41S420.718,754.326,419.246,763Z",
    transform: "translate(-393.023 -716.143)",
    fill: "url(#linear-gradient-58)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7607",
    "data-name": "Path 7607",
    d: "M422.008,790.985a24.769,24.769,0,0,0,9.073.032c-19.677-.731-20.638-18.843-19.423-24.757,1.395-6.774.319-15.772-4.789-24.288-3.755-6.257-2.873-10.69-2.142-12.6-2.431.416-3.349,2.607-3.043,7.4a18.546,18.546,0,0,0,.533,3.36c.995,3.939,3,7.24,3.8,11.855,1.014,5.859-1.31,12.744-1,20.574S410.742,788.869,422.008,790.985Z",
    transform: "translate(-401.626 -728.475)",
    fill: "url(#linear-gradient-59)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7608",
    "data-name": "Path 7608",
    d: "M402.216,740.168a11.089,11.089,0,0,0,10.608-3.085c-1.591-4.412-3.761-7.553-6.683-7.731-3.487-.214-4.815,1.835-4.458,7.456A18.546,18.546,0,0,0,402.216,740.168Z",
    transform: "translate(-401.626 -728.512)",
    fill: "url(#linear-gradient-60)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7609",
    "data-name": "Path 7609",
    d: "M416.483,736.414c1.014,3.228,7.517,3.665,7.751.686-1.775-5.982-5.316-5.762-7.119-5.2A5.991,5.991,0,0,0,416.483,736.414Z",
    transform: "translate(-387.253 -726.256)",
    fill: "url(#linear-gradient-61)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7610",
    "data-name": "Path 7610",
    d: "M420.771,742.509c1.064,4.882,8.213,4.21,9.4.537a5.124,5.124,0,0,0-1.742-4.914c-3.778-3.247-7.238.854-7.381,1.028l0,.008A6,6,0,0,0,420.771,742.509Z",
    transform: "translate(-382.959 -721.103)",
    fill: "url(#linear-gradient-62)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7611",
    "data-name": "Path 7611",
    d: "M426.006,756.137a5.527,5.527,0,0,0,1.692-.426c.991-.448,1.89-.848,2.724-1.246A8.428,8.428,0,0,0,426.9,746.5c-2.172,1.528-4.212,3.489-4.282,5.011C422.533,753.405,423.177,756.161,426.006,756.137Z",
    transform: "translate(-381.032 -711.672)",
    fill: "url(#linear-gradient-63)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7612",
    "data-name": "Path 7612",
    d: "M423.159,762.981l.02.008c1.222.41,3.376.618,6.961-.4a6.606,6.606,0,0,0-.139-5.221,5.814,5.814,0,0,0-2.556-2.829C420.956,758.9,419.641,761.338,423.159,762.981Z",
    transform: "translate(-382.364 -703.78)",
    fill: "url(#linear-gradient-64)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2400",
    "data-name": "Group 2400",
    transform: "translate(188.746 197.622)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7613",
    "data-name": "Path 7613",
    d: "M404.753,889.764s-2.72-9.013-2.1-13.753,27.743-70.794,63.14-70.7Z",
    transform: "translate(-402.558 -805.31)",
    fill: "#aca5b5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7614",
    "data-name": "Path 7614",
    d: "M412.178,912.561s-7.914-6.313-8.643-27.111,41.621-93.215,67.4-78.062Z",
    transform: "translate(-401.608 -805.3)",
    fill: "url(#linear-gradient-65)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7615",
    "data-name": "Path 7615",
    d: "M475.494,833.131c-.006.85-.03,1.712-.063,2.594a129.67,129.67,0,0,1-1.3,13.979q-.178,1.237-.386,2.5c-.705,4.319-1.643,8.837-2.841,13.507-.208.8-.42,1.607-.642,2.417a166.572,166.572,0,0,1-5.28,16.029q-.449,1.162-.921,2.334c-1.864,4.627-3.994,9.322-6.412,14.048q-.577,1.129-1.173,2.257-3.228,6.084-7.115,12.2c-.212.337-.43.674-.648,1.012l-.006.006c-.533.321-1.066.624-1.6.907-18.758,9.9-41.365-2.95-41.452-12.38,0-.1,0-.2.008-.311a21,21,0,0,1,.329-2.516c.539-3,1.686-7.7,3.3-13.362.222-.783.456-1.589.7-2.405,1.318-4.484,2.891-9.455,4.648-14.587.269-.783.545-1.571.82-2.364,1.851-5.272,3.885-10.654,6.031-15.8.323-.777.652-1.549.979-2.314,1.934-4.492,3.945-8.754,5.988-12.544.412-.765.828-1.51,1.24-2.237.5-.87,1-1.712,1.5-2.516a106.253,106.253,0,0,1,6.529-9.4c.561-.717,1.123-1.419,1.688-2.1a62.17,62.17,0,0,1,12.9-12.061q1.456-.975,2.877-1.738c5.14-2.78,9.853-3.515,13.608-2.009,1.835.737,3.483,3.4,4.684,7.61q.38,1.32.693,2.831A76.963,76.963,0,0,1,475.494,833.131Z",
    transform: "translate(-399.527 -805.119)",
    fill: "url(#linear-gradient-66)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2399",
    "data-name": "Group 2399",
    transform: "translate(6.128 3.162)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7616",
    "data-name": "Path 7616",
    d: "M451.056,815.339l-21.862-6.695q1.456-.975,2.877-1.738l18.292,5.6Q450.743,813.827,451.056,815.339Z",
    transform: "translate(-382.547 -806.906)",
    fill: "#988ca5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7617",
    "data-name": "Path 7617",
    d: "M459.611,824.922c-.006.85-.03,1.712-.063,2.594l-37.715-11.55c.561-.717,1.123-1.419,1.688-2.1Z",
    transform: "translate(-389.771 -800.072)",
    fill: "#988ca5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7618",
    "data-name": "Path 7618",
    d: "M462.835,834.552q-.178,1.237-.386,2.5l-45.294-13.87c.412-.765.828-1.51,1.24-2.237Z",
    transform: "translate(-394.361 -793.13)",
    fill: "#988ca5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7619",
    "data-name": "Path 7619",
    d: "M463.058,843.237c-.208.8-.42,1.607-.642,2.417l-48.777-14.936c.323-.777.652-1.549.979-2.314Z",
    transform: "translate(-397.812 -785.809)",
    fill: "#988ca5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7620",
    "data-name": "Path 7620",
    d: "M460.53,852.711q-.449,1.162-.921,2.334L410.181,839.91c.269-.783.545-1.571.82-2.364Z",
    transform: "translate(-401.205 -776.837)",
    fill: "#988ca5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7621",
    "data-name": "Path 7621",
    d: "M455.844,860.7q-.577,1.129-1.173,2.257l-47.188-14.448c.222-.783.456-1.589.7-2.405Z",
    transform: "translate(-403.853 -768.441)",
    fill: "#988ca5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7622",
    "data-name": "Path 7622",
    d: "M449.354,867.34c-.212.337-.43.674-.648,1.012l-.006.006c-.533.321-1.066.624-1.6.907l-41.444-12.691a21,21,0,0,1,.329-2.516Z",
    transform: "translate(-405.651 -760.631)",
    fill: "#988ca5"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2402",
    "data-name": "Group 2402",
    transform: "translate(0 264.665)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7623",
    "data-name": "Path 7623",
    d: "M410.1,874s-3.547-8.722-7-12.023-66.057-37.654-93.54-15.346Z",
    transform: "translate(-305.078 -839.147)",
    fill: "#aca5b5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7624",
    "data-name": "Path 7624",
    d: "M419.613,896.3s2.189-9.885-10.307-26.527-90.941-46.38-101.476-18.4Z",
    transform: "translate(-306.776 -838.442)",
    fill: "url(#linear-gradient-67)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7625",
    "data-name": "Path 7625",
    d: "M319.468,874.176c.539.656,1.1,1.312,1.68,1.977a130.318,130.318,0,0,0,9.794,10.059q.913.847,1.87,1.7c3.261,2.919,6.83,5.843,10.693,8.724.666.491,1.337.987,2.021,1.478a166.2,166.2,0,0,0,14.177,9.154c.719.416,1.446.83,2.183,1.236,4.357,2.429,8.964,4.747,13.812,6.9.773.345,1.547.683,2.332,1.018q6.331,2.708,13.2,5.021c.376.129.757.254,1.139.38h.01q.921-.125,1.817-.3c20.816-4.08,30.333-28.282,24.476-35.673-.059-.073-.127-.153-.2-.238a21.579,21.579,0,0,0-1.837-1.75c-2.3-1.993-6.15-4.932-10.963-8.324-.666-.47-1.353-.949-2.055-1.435-3.842-2.661-8.189-5.54-12.78-8.429-.7-.44-1.411-.88-2.122-1.323-4.753-2.938-9.717-5.847-14.619-8.5-.739-.4-1.48-.8-2.215-1.187-4.325-2.279-8.567-4.331-12.54-6-.8-.337-1.591-.656-2.37-.961-.933-.365-1.853-.705-2.746-1.016a106.22,106.22,0,0,0-10.985-3.216c-.89-.206-1.767-.4-2.633-.571a62.2,62.2,0,0,0-17.61-1.282q-1.745.157-3.329.456c-5.748,1.066-9.877,3.453-11.851,6.986-.967,1.726-.573,4.834,1.135,8.863q.532,1.266,1.238,2.639A77.128,77.128,0,0,0,319.468,874.176Z",
    transform: "translate(-307.298 -836.894)",
    fill: "url(#linear-gradient-68)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2401",
    "data-name": "Group 2401",
    transform: "translate(1.653 4.728)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7626",
    "data-name": "Path 7626",
    d: "M309.37,860.477l12.806-18.944q-1.745.157-3.329.456l-10.715,15.849Q308.664,859.1,309.37,860.477Z",
    transform: "translate(-308.132 -841.533)",
    fill: "#988ca5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7627",
    "data-name": "Path 7627",
    d: "M313.44,873.452c.539.656,1.1,1.312,1.68,1.977l22.09-32.679c-.89-.206-1.767-.4-2.633-.571Z",
    transform: "translate(-302.923 -840.898)",
    fill: "#988ca5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7628",
    "data-name": "Path 7628",
    d: "M319.231,883.11q.913.847,1.87,1.7l26.527-39.245c-.8-.337-1.591-.656-2.37-.961Z",
    transform: "translate(-297.24 -838.519)",
    fill: "#988ca5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7629",
    "data-name": "Path 7629",
    d: "M325.572,890.087c.666.491,1.337.987,2.021,1.478L356.16,849.3c-.739-.4-1.48-.8-2.215-1.187Z",
    transform: "translate(-291.017 -835.073)",
    fill: "#988ca5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7630",
    "data-name": "Path 7630",
    d: "M333.747,895.919c.719.416,1.446.83,2.183,1.236l28.948-42.825c-.7-.44-1.411-.88-2.122-1.323Z",
    transform: "translate(-282.994 -830.273)",
    fill: "#988ca5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7631",
    "data-name": "Path 7631",
    d: "M341.82,899.229c.773.345,1.547.683,2.332,1.018l27.638-40.884c-.666-.47-1.353-.949-2.055-1.435Z",
    transform: "translate(-275.072 -825.442)",
    fill: "#988ca5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7632",
    "data-name": "Path 7632",
    d: "M349.657,900.435c.376.129.757.254,1.139.38h.01q.921-.125,1.817-.3L376.9,864.6a21.579,21.579,0,0,0-1.837-1.75Z",
    transform: "translate(-267.381 -820.609)",
    fill: "#988ca5"
  }))))), /*#__PURE__*/React.createElement("path", {
    id: "Path_7633",
    "data-name": "Path 7633",
    d: "M570.681,914.787q-.312-1.51-.693-2.831c-1.2-4.208-2.849-6.873-4.684-7.61a11.108,11.108,0,0,0-4.193-.761,14.7,14.7,0,0,0-1.9-.3l.067-.091c-.422,0-.84.01-1.26.028a18.369,18.369,0,0,0-5.013.644c-7.872,1.692-15.253,6.455-21.922,12.762-.479-4.062-1.4-12.088-2.162-19.976a35.414,35.414,0,0,0-6.249-16.511,20.748,20.748,0,0,0-5.278-5.566s-5.058-19.073-16.955-23.586c-.228-.087-.452-.17-.674-.248-.119-.046-.238-.085-.353-.127l-.01,0a27.022,27.022,0,0,0-11.161-1.643l0,0a9.8,9.8,0,0,0-2.1.3l-.069.014c-.176.038-.349.075-.515.115a13.8,13.8,0,0,0-2.54.864l-.028.016c-.206.083-.416.168-.636.266l.053-.081.052-.081.012-.024c.02-.03.038-.065.057-.1l.014-.028c.02-.038.04-.077.061-.121l.016-.036c.02-.044.042-.091.063-.143l.014-.036c.022-.054.046-.111.067-.17l.008-.026a6.833,6.833,0,0,0,.275-1.01l.012-.059c.014-.083.03-.172.044-.261l.016-.107c.014-.087.026-.178.036-.271l.016-.131c.01-.1.018-.192.026-.293l.012-.145c.006-.1.012-.21.018-.319l0-.145c0-.119.008-.238.008-.363v-.073c0-.325-.008-.67-.03-1.04-.014-.226-.03-.46-.054-.7q-.062-.642-.172-1.373a11.651,11.651,0,0,0,3.089-1.139,13.8,13.8,0,0,0,4.775-3.905,4.562,4.562,0,0,0-.093-5.5A6.688,6.688,0,0,0,487,830.709a29.868,29.868,0,0,0-5.809-.953,39.765,39.765,0,0,0-.5-5.889c-.044-.258-.089-.517-.137-.773l0,0a23.514,23.514,0,0,0-1.074-3.874s1.175.807,3.127,1.851c.111.065.208.119.289.162.036.016.071.036.107.056.115.061.174.089.174.089l0,0c4.525,2.356,12.485,5.585,19.727,3.909a15.968,15.968,0,0,0,2-.6,23.706,23.706,0,0,0,2.582-1.139,20.627,20.627,0,0,0,9.051-8.92,24.723,24.723,0,0,0,7.113-.252,23.8,23.8,0,0,0,9.94-4.193,2.92,2.92,0,0,0,1.4.852l.02.008c.081.026.167.054.256.077l.075.02c.065.018.133.036.2.052l.1.022c.065.014.133.028.2.04l.121.022c.069.01.139.022.212.032l.135.016c.073.008.151.016.228.022l.145.012c.081.006.165.01.25.014l.151.006c.089,0,.182,0,.277,0h.151c.1,0,.21-.006.317-.01l.143-.006c.123-.006.252-.016.382-.028l.109-.008c.345-.032.713-.077,1.1-.141l.012,0c.188-.032.382-.067.58-.107l.137-.028c.162-.034.325-.067.491-.107.063-.014.127-.03.19-.046.156-.038.313-.075.475-.119.073-.018.149-.04.222-.059.1-.026.19-.05.289-.077l.246-.073.1-.03c.24-.069.481-.145.731-.228,7.573-2.479,9.534-7.119,8.855-10.184a2.577,2.577,0,0,0-1.71-1.793l-.01,0c-2.183-.886-5.787-.454-7.339-.27-2.172.26-2.867-.285-2.122-1.948a1.388,1.388,0,0,1,.143-.242c.991-.448,1.89-.848,2.724-1.246a23.343,23.343,0,0,0,4.793-2.889c2.3-1.849,3.131-5.409,2.411-8.785-.357-1.662-2.041-2.328-4.107-2.253a12.907,12.907,0,0,0-6.59,2.273c-3.772,2.653-5.4,2.219-5.968.083-.4-1.512,2.374-4.2,4.9-6.746l.17-.174a4.087,4.087,0,0,0,2.211-2.358l.032-.04c.117-.137.228-.273.333-.406,2.459-3.127-.343-8.141-5.693-8.131a4.147,4.147,0,0,0-1.524.283h0c-3.887,1.543-4.294,8.809-6.891,8.276-2.9-.6-1.339-3.3,1.593-7.743.382-.584.773-1.213,1.145-1.87.034-.061.067-.125.1-.188a1.812,1.812,0,0,0,.672-1.28l.016-.034c.052-.1.1-.212.152-.319l.042-.087c.047-.1.1-.206.143-.309l.042-.093c.046-.1.093-.206.137-.309l.034-.081q.205-.481.384-.965c.02-.052.04-.1.059-.156.026-.075.053-.153.079-.228l.065-.19c.024-.071.046-.145.069-.216s.042-.135.063-.2.042-.141.061-.212.04-.135.057-.2.038-.139.055-.208.034-.137.052-.2l.048-.2c.016-.069.03-.137.044-.206l.042-.2c.014-.073.026-.145.038-.216s.022-.123.032-.182q.027-.181.047-.357c.006-.065.012-.127.018-.19s.014-.147.02-.22.006-.121.01-.182.006-.133.008-.2,0-.123,0-.184,0-.125,0-.188,0-.123-.008-.184-.008-.119-.012-.18-.012-.121-.018-.18-.014-.117-.024-.174-.016-.119-.028-.176-.022-.115-.034-.17-.024-.113-.038-.17-.032-.113-.048-.17-.03-.105-.047-.159c-.022-.069-.05-.139-.077-.208s-.059-.151-.093-.224c-.028-.057-.054-.117-.083-.174s-.052-.093-.077-.139-.057-.1-.089-.153-.059-.089-.089-.135-.067-.1-.1-.143-.067-.085-.1-.127-.077-.091-.119-.137-.073-.079-.113-.119-.089-.087-.135-.129-.079-.073-.123-.109-.1-.083-.159-.125-.083-.065-.127-.1c-.063-.046-.129-.087-.2-.131-.04-.024-.077-.05-.117-.073-.111-.065-.224-.127-.345-.184a3.72,3.72,0,0,0-3.059-.012c-4.365,1.668-9.5,9.689-11.692,18.768a39.013,39.013,0,0,1-2.1,6.707c-1.04,2.277-1.75,2.144-2.067,1.89a.771.771,0,0,1-.184-.212c-1.252-1.266-3.606-10.424-5.241-16.208-.268-.937-.551-1.843-.858-2.7-1.591-4.412-3.761-7.553-6.683-7.731-.117-.008-.232-.012-.345-.014h-.151c-.059,0-.121,0-.18,0l-.162.008-.16.012c-.052,0-.1.01-.155.016s-.1.012-.156.02c-.034.006-.071.01-.1.016l-.03.006c-.125.022-.246.049-.363.081l-.091.028a3.369,3.369,0,0,0-.337.117l-.065.032a2.615,2.615,0,0,0-.279.141l-.059.032c-.1.06-.188.125-.277.192l-.073.057a2.974,2.974,0,0,0-.246.228l-.059.065c-.071.079-.141.162-.206.252l-.04.053a3.213,3.213,0,0,0-.188.3c-.016.03-.034.059-.05.089-.057.109-.113.224-.162.343l-.044.107c-.05.125-.1.255-.141.392l-.024.081c-.036.127-.071.258-.1.394-.008.038-.018.073-.026.111-.032.152-.061.311-.087.476l-.022.141c-.024.168-.046.345-.061.525l-.01.121q-.024.261-.036.541l-.006.1c-.008.206-.012.42-.014.64v.153c0,.222,0,.45.012.686l.006.141c.008.254.02.509.038.779a18.546,18.546,0,0,0,.533,3.36c.995,3.939,3,7.24,3.8,11.855a20.1,20.1,0,0,1,.252,3.832c-.624.232-1.3.511-2,.85a19.257,19.257,0,0,0-3.543,2.209h0c-.129.1-.256.206-.382.311v0a.248.248,0,0,0-.04.034l-.012.006-.012.01-.008.01c-.192.162-.38.331-.567.5-.061.057-.121.119-.18.176-.121.115-.24.23-.357.351-.093.1-.184.2-.277.3-.077.083-.155.167-.232.254-.109.125-.216.256-.323.386-.038.046-.077.087-.113.133-.063.077-.129.156-.188.236A23.721,23.721,0,0,0,488.257,782a20.814,20.814,0,0,0-8.074-5.625q-.487-1.165-1.044-2.3c-.975-6.713-2.778-15.536-4.347-16.7-1.5-1.121-2.633-2.534-11.5-1.629-.252-.168-.505-.333-.757-.5a24.145,24.145,0,0,0,1.1-2.911q.155-2.158.125-4.25c1.69-.545,5.191-1.732,6.174-2.52,2.187-1.754-4.47-23.418-6.921-23.422-.866,0-5.324.539-7.341.789A36.424,36.424,0,0,0,424.8,707.8l-.987-2.229c-7.081.143-13.067,1.922-17.783,5.6l.553,1.841c-11.179,6.527-16.982,18.492-17.008,31-1.736.989-5.714,3.267-6.416,3.79-1.962,1.468,5.653,22.813,8.453,22.912,1.226.044,4.579-1.032,6.309-1.619.656.88,1.349,1.744,2.082,2.584-8.088,3.136-13.2,5.744-13.969,6.776-1.062,1.422.547,8.1,1.938,13.016-2.837,1.865-6.128,5.75-7.232,13.838-.057.4-.107.812-.151,1.234a3.973,3.973,0,0,0-1.635.791,5.539,5.539,0,0,0-1.341,1.5c-.079.129-.157.262-.232.4s-.153.3-.226.468c-.02.042-.038.085-.055.127-.059.143-.119.291-.174.446l-.034.093c-.065.186-.125.384-.18.59l-.03.115c-.049.186-.093.38-.135.583l-.014.063-.008.048c-.03.155-.057.317-.083.481-.008.052-.016.1-.024.155-.03.214-.056.432-.075.66v0a.061.061,0,0,0-.006.026s-.014-.034-.044-.091l0-.006-.059-.111-.038-.061-.055-.093-.048-.075c-.026-.038-.052-.079-.081-.123l-.055-.079c-.038-.052-.077-.1-.121-.161l-.055-.073c-.063-.079-.131-.16-.206-.248-.022-.026-.049-.053-.073-.079-.057-.065-.115-.129-.18-.2s-.119-.117-.178-.176l-.073-.073-.04-.036c-.05-.046-.1-.091-.149-.137-.1-.093-.21-.188-.329-.283l-.01-.008a10.847,10.847,0,0,0-1.191-.84l-.012-.006a15.616,15.616,0,0,0-3.945-1.651c-1.468-5.052-3.325-9.524-3.392-13.792-.071-4.684,1.288-8.3,1.532-12.358a18.652,18.652,0,0,0-.1-3.4c-.032-.267-.069-.523-.107-.773l-.02-.139c-.038-.232-.075-.458-.117-.676l-.028-.151c-.044-.216-.087-.426-.133-.626l-.024-.091c-.042-.182-.087-.357-.135-.525l-.032-.117q-.077-.262-.16-.505l-.046-.133c-.057-.156-.115-.309-.176-.452l-.046-.1c-.056-.129-.115-.254-.174-.37l-.038-.073c-.067-.127-.139-.246-.21-.36l-.063-.1c-.071-.107-.147-.21-.224-.307l-.065-.077a3.381,3.381,0,0,0-.24-.26l-.05-.046a3,3,0,0,0-.25-.208c-.024-.018-.046-.038-.071-.054a2.475,2.475,0,0,0-.281-.176l-.083-.044a2.657,2.657,0,0,0-.307-.137l-.065-.022a2.938,2.938,0,0,0-.3-.087l-.071-.018c-.113-.024-.23-.04-.351-.054l-.1-.008c-.121-.01-.244-.016-.37-.014l-.03,0c-.036,0-.071.006-.107.006-.052,0-.1,0-.157.008l-.157.014c-.052.006-.1.012-.158.02s-.105.014-.16.022-.119.02-.178.032l-.149.028c-.109.024-.222.047-.335.077-2.839.719-4.387,4.208-5.13,8.841-.143.9-.254,1.837-.341,2.807-.531,5.986-1.139,15.423-2.136,16.9a.8.8,0,0,1-.143.242c-.264.309-.935.571-2.38-1.474a38.877,38.877,0,0,1-3.309-6.2c-3.838-8.514-10.378-15.437-14.977-16.267a3.725,3.725,0,0,0-3,.58c-.107.079-.208.163-.3.246-.036.032-.067.063-.1.1-.059.054-.117.107-.17.164-.038.038-.071.077-.107.117s-.091.1-.133.153-.067.085-.1.129-.075.1-.109.153-.061.091-.089.139-.061.1-.091.155-.052.1-.075.145-.052.1-.075.158-.044.1-.063.149-.04.111-.059.167-.034.1-.049.151-.032.125-.048.186q-.03.122-.053.244c-.012.071-.026.143-.036.214-.006.055-.01.111-.016.167s-.012.115-.016.174,0,.117,0,.174,0,.115,0,.172,0,.121.006.18.006.117.01.174.01.121.016.182.014.119.022.178.016.121.026.182.022.123.034.186.022.121.036.18.028.127.044.192.028.119.044.178.04.141.059.21.036.125.055.186c.036.113.071.226.113.339.02.06.044.119.065.176s.05.137.075.2l.077.188c.028.063.053.129.081.194s.057.127.085.192l.087.188.1.2c.03.061.061.125.093.186l.1.2c.032.062.065.123.1.182s.073.135.111.2.065.117.1.174l.121.21c.028.047.057.1.085.143.178.3.367.59.561.882l.046.067c.061.093.127.184.19.277l.059.085c.065.093.131.184.2.277l.055.077c.071.095.141.192.212.287l.022.028a1.8,1.8,0,0,0,.9,1.133c.046.056.091.111.137.165.487.577.987,1.123,1.472,1.625,3.705,3.82,5.746,6.186,3,7.311-2.451,1.007-4.2-6.055-8.308-6.849l0,0a4.115,4.115,0,0,0-1.549,0c-5.257.985-7.077,6.434-4.082,9.049.129.111.264.224.4.337l.04.034a4.1,4.1,0,0,0,2.611,1.906l.2.139c2.958,2.033,6.188,4.157,6.071,5.718-.162,2.2-1.678,2.932-5.881,1.026a12.926,12.926,0,0,0-6.9-1.009c-2.047.313-3.578,1.278-3.618,2.978-.077,3.452,1.4,6.794,4,8.183a23.258,23.258,0,0,0,5.247,1.948c.894.236,1.853.462,2.909.719a1.3,1.3,0,0,1,.184.21c1.042,1.494.46,2.162-1.722,2.31-1.559.1-5.181.353-7.161,1.629l-.01,0a2.578,2.578,0,0,0-1.345,2.08c-.1,3.141,2.693,7.333,10.592,8.361.261.034.513.063.761.087l.1.012.256.026.3.022.232.018c.164.012.327.02.485.028.065,0,.133.008.2.01.17.008.337.01.5.014l.143,0c.2,0,.4,0,.588,0h.014c.4-.01.765-.034,1.112-.065l.107-.014c.131-.012.258-.028.38-.044.05-.006.1-.014.143-.022.107-.016.21-.032.311-.05.052-.008.1-.018.151-.028.093-.018.184-.036.271-.056l.147-.032c.083-.02.164-.04.244-.062l.139-.038.222-.065.127-.04.2-.071.113-.042c.067-.026.129-.052.192-.077l.1-.042c.065-.028.127-.057.186-.087l.075-.036c.083-.04.161-.081.236-.123l.018-.01a2.957,2.957,0,0,0,1.219-1.1,23.2,23.2,0,0,0,8.571,2.205L346.4,838s8.762,9.3,21.379,10.44a27.359,27.359,0,0,0,7.654-.365,29.4,29.4,0,0,0,5.982-1.815s5.356,1.472,12.922-2.823l.016-.01c.69-.392,1.4-.832,2.124-1.326,0,0,.269,1.207.689,2.542.1.305.2.616.305.921l-.008-.02s-.055.044-.153.125c-.065.053-.149.125-.25.212-.151.129-.339.291-.555.483-1.819,1.617-5.57,5.247-5.187,7.363.4,2.231,2.328,3.148,5.473,3.1-.268.158-1.413.836-2.851,1.722l-.026.012c-2.118,1.3-4.862,3.031-6.366,4.188l-.121.1-.012.008c-2.582,2.055-3.675,4.9-8.064,8.282-4.462,3.436-4.294,5.93-6.008,12.938-.747,3.057-1.555,6.115-2.225,8.6-.872,3.206-1.516,5.439-1.516,5.439a26.836,26.836,0,0,0-3,3.444l-.089.121-.032.046c-.044.06-.085.115-.129.176l-.071.1-.006,0v0a29.145,29.145,0,0,0-1.936,3.081,24.549,24.549,0,0,0-1.656,3.765,20.425,20.425,0,0,0-.652,2.3,64.415,64.415,0,0,0-1.24,9c-.083,1.209-.135,2.314-.164,3.265-.065,2.132-.026,3.491-.026,3.491a23.8,23.8,0,0,0-1.975,2.758l-.008.012a30.128,30.128,0,0,0-2.762,5.605,24.385,24.385,0,0,0-1.446,6.453c-.59,7.458,7.666,28.046,9.7,32.992-16.295-4.769-34.155-6.943-47.04-.438a18.4,18.4,0,0,0-4.3,2.647c-.337.25-.672.505-1,.771l.109.03a14.721,14.721,0,0,0-1.29,1.431,11.043,11.043,0,0,0-2.784,3.226c-.967,1.726-.573,4.834,1.135,8.863q.532,1.266,1.238,2.639a77.128,77.128,0,0,0,9.279,13.61c.539.656,1.1,1.312,1.68,1.977a130.318,130.318,0,0,0,9.794,10.059q.913.847,1.87,1.7c3.261,2.919,6.83,5.843,10.7,8.724.664.491,1.336.987,2.019,1.478a166.229,166.229,0,0,0,14.177,9.154c.719.416,1.446.83,2.183,1.236,4.357,2.429,8.964,4.747,13.812,6.9.773.345,1.547.684,2.332,1.019q6.331,2.707,13.2,5.021c.376.129.757.253,1.139.38h.01q.921-.125,1.817-.3c15.215-2.982,24.391-16.713,25.942-26.772a6.322,6.322,0,0,0,.089-.644,13.34,13.34,0,0,0-.612-6.618c-.894-3.872-2.913-9.2-7.287-15.746a64.5,64.5,0,0,0-4.288-8.49,172.166,172.166,0,0,0-.256-20.907c-1.034-10.577-4.414-18.8-3.862-24.478,0,0,5.051-2.33,9.2-19.829.517-2.164,1.014-4.557,1.488-7.206,0,0,.133-.038.375-.115,2.181-.7,13.329-4.7,17.727-14.587,4.888-10.983,9.792-12.57,12.413-10.87s13.673,12.221,29.9,11.428c0,0,.468,1.052,1.351,2.663v0a52.584,52.584,0,0,0,4.1,6.372c2.6,3.444,6.045,7.01,10.186,9a108.182,108.182,0,0,1,1.532,22.445c-.25,10.146.9,22.675,4.428,30.329a69.662,69.662,0,0,0,1.619,6.8c.709,7.846,2.485,13.257,4.22,16.832a13.366,13.366,0,0,0,3.681,5.532,5.886,5.886,0,0,0,.474.444c7.527,6.854,23.293,11.773,37,4.535.539-.283,1.072-.587,1.6-.907l.006-.006c.218-.339.436-.676.648-1.012q3.9-6.1,7.115-12.2.6-1.129,1.173-2.257c2.419-4.726,4.547-9.421,6.412-14.048q.473-1.171.921-2.334a166.571,166.571,0,0,0,5.28-16.029c.222-.81.434-1.617.642-2.417,1.2-4.67,2.136-9.188,2.841-13.507q.208-1.263.386-2.5a129.654,129.654,0,0,0,1.3-13.979c.034-.882.057-1.744.065-2.594A77.072,77.072,0,0,0,570.681,914.787Zm-204.23-13.006-.012.018.016-.024ZM397,854a3.513,3.513,0,0,1-.382-.052,1.973,1.973,0,0,1-.808-.313,1.082,1.082,0,0,1-.305-.327,1.154,1.154,0,0,1-.091-.194,1.385,1.385,0,0,1-.071-.44,3.642,3.642,0,0,1,.478-1.583c.1-.188.2-.376.317-.565.228-.376.483-.745.741-1.09.065-.085.129-.17.192-.252q.193-.25.374-.469c.543-.66.977-1.108.977-1.108A28.1,28.1,0,0,0,397,854Zm83.98-18.833,0,.016s6.713-1.179,7.755.315c.749,1.078.256,2.726-2.421,3.723a14.726,14.726,0,0,1-4.056.789c-.335-1.282-.773-2.706-1.337-4.292C480.918,835.718,480.943,835.522,480.979,835.167Z",
    transform: "translate(-307.298 -705.57)",
    fill: "url(#linear-gradient-69)",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7634",
    "data-name": "Path 7634",
    d: "M570.681,914.787q-.312-1.51-.693-2.831c-1.2-4.208-2.849-6.873-4.684-7.61a11.108,11.108,0,0,0-4.193-.761,14.7,14.7,0,0,0-1.9-.3l.067-.091c-.422,0-.84.01-1.26.028a18.369,18.369,0,0,0-5.013.644c-7.872,1.692-15.253,6.455-21.922,12.762-.479-4.062-1.4-12.088-2.162-19.976a35.414,35.414,0,0,0-6.249-16.511,20.748,20.748,0,0,0-5.278-5.566s-5.058-19.073-16.955-23.586c-.228-.087-.452-.17-.674-.248-.119-.046-.238-.085-.353-.127l-.01,0a27.022,27.022,0,0,0-11.161-1.643l0,0a9.8,9.8,0,0,0-2.1.3l-.069.014c-.176.038-.349.075-.515.115a13.8,13.8,0,0,0-2.54.864l-.028.016c-.206.083-.416.168-.636.266l.053-.081.052-.081.012-.024c.02-.03.038-.065.057-.1l.014-.028c.02-.038.04-.077.061-.121l.016-.036c.02-.044.042-.091.063-.143l.014-.036c.022-.054.046-.111.067-.17l.008-.026a6.833,6.833,0,0,0,.275-1.01l.012-.059c.014-.083.03-.172.044-.261l.016-.107c.014-.087.026-.178.036-.271l.016-.131c.01-.1.018-.192.026-.293l.012-.145c.006-.1.012-.21.018-.319l0-.145c0-.119.008-.238.008-.363v-.073c0-.325-.008-.67-.03-1.04-.014-.226-.03-.46-.054-.7q-.062-.642-.172-1.373a11.651,11.651,0,0,0,3.089-1.139,13.8,13.8,0,0,0,4.775-3.905,4.562,4.562,0,0,0-.093-5.5A6.688,6.688,0,0,0,487,830.709a29.868,29.868,0,0,0-5.809-.953,39.765,39.765,0,0,0-.5-5.889c-.044-.258-.089-.517-.137-.773l0,0a23.514,23.514,0,0,0-1.074-3.874s1.175.807,3.127,1.851c.111.065.208.119.289.162.036.016.071.036.107.056.115.061.174.089.174.089l0,0c4.525,2.356,12.485,5.585,19.727,3.909a15.968,15.968,0,0,0,2-.6,23.706,23.706,0,0,0,2.582-1.139,20.627,20.627,0,0,0,9.051-8.92,24.723,24.723,0,0,0,7.113-.252,23.8,23.8,0,0,0,9.94-4.193,2.92,2.92,0,0,0,1.4.852l.02.008c.081.026.167.054.256.077l.075.02c.065.018.133.036.2.052l.1.022c.065.014.133.028.2.04l.121.022c.069.01.139.022.212.032l.135.016c.073.008.151.016.228.022l.145.012c.081.006.165.01.25.014l.151.006c.089,0,.182,0,.277,0h.151c.1,0,.21-.006.317-.01l.143-.006c.123-.006.252-.016.382-.028l.109-.008c.345-.032.713-.077,1.1-.141l.012,0c.188-.032.382-.067.58-.107l.137-.028c.162-.034.325-.067.491-.107.063-.014.127-.03.19-.046.156-.038.313-.075.475-.119.073-.018.149-.04.222-.059.1-.026.19-.05.289-.077l.246-.073.1-.03c.24-.069.481-.145.731-.228,7.573-2.479,9.534-7.119,8.855-10.184a2.577,2.577,0,0,0-1.71-1.793l-.01,0c-2.183-.886-5.787-.454-7.339-.27-2.172.26-2.867-.285-2.122-1.948a1.388,1.388,0,0,1,.143-.242c.991-.448,1.89-.848,2.724-1.246a23.343,23.343,0,0,0,4.793-2.889c2.3-1.849,3.131-5.409,2.411-8.785-.357-1.662-2.041-2.328-4.107-2.253a12.907,12.907,0,0,0-6.59,2.273c-3.772,2.653-5.4,2.219-5.968.083-.4-1.512,2.374-4.2,4.9-6.746l.17-.174a4.087,4.087,0,0,0,2.211-2.358l.032-.04c.117-.137.228-.273.333-.406,2.459-3.127-.343-8.141-5.693-8.131a4.147,4.147,0,0,0-1.524.283h0c-3.887,1.543-4.294,8.809-6.891,8.276-2.9-.6-1.339-3.3,1.593-7.743.382-.584.773-1.213,1.145-1.87.034-.061.067-.125.1-.188a1.812,1.812,0,0,0,.672-1.28l.016-.034c.052-.1.1-.212.152-.319l.042-.087c.047-.1.1-.206.143-.309l.042-.093c.046-.1.093-.206.137-.309l.034-.081q.205-.481.384-.965c.02-.052.04-.1.059-.156.026-.075.053-.153.079-.228l.065-.19c.024-.071.046-.145.069-.216s.042-.135.063-.2.042-.141.061-.212.04-.135.057-.2.038-.139.055-.208.034-.137.052-.2l.048-.2c.016-.069.03-.137.044-.206l.042-.2c.014-.073.026-.145.038-.216s.022-.123.032-.182q.027-.181.047-.357c.006-.065.012-.127.018-.19s.014-.147.02-.22.006-.121.01-.182.006-.133.008-.2,0-.123,0-.184,0-.125,0-.188,0-.123-.008-.184-.008-.119-.012-.18-.012-.121-.018-.18-.014-.117-.024-.174-.016-.119-.028-.176-.022-.115-.034-.17-.024-.113-.038-.17-.032-.113-.048-.17-.03-.105-.047-.159c-.022-.069-.05-.139-.077-.208s-.059-.151-.093-.224c-.028-.057-.054-.117-.083-.174s-.052-.093-.077-.139-.057-.1-.089-.153-.059-.089-.089-.135-.067-.1-.1-.143-.067-.085-.1-.127-.077-.091-.119-.137-.073-.079-.113-.119-.089-.087-.135-.129-.079-.073-.123-.109-.1-.083-.159-.125-.083-.065-.127-.1c-.063-.046-.129-.087-.2-.131-.04-.024-.077-.05-.117-.073-.111-.065-.224-.127-.345-.184a3.72,3.72,0,0,0-3.059-.012c-4.365,1.668-9.5,9.689-11.692,18.768a39.013,39.013,0,0,1-2.1,6.707c-1.04,2.277-1.75,2.144-2.067,1.89a.771.771,0,0,1-.184-.212c-1.252-1.266-3.606-10.424-5.241-16.208-.268-.937-.551-1.843-.858-2.7-1.591-4.412-3.761-7.553-6.683-7.731-.117-.008-.232-.012-.345-.014h-.151c-.059,0-.121,0-.18,0l-.162.008-.16.012c-.052,0-.1.01-.155.016s-.1.012-.156.02c-.034.006-.071.01-.1.016l-.03.006c-.125.022-.246.049-.363.081l-.091.028a3.369,3.369,0,0,0-.337.117l-.065.032a2.615,2.615,0,0,0-.279.141l-.059.032c-.1.06-.188.125-.277.192l-.073.057a2.974,2.974,0,0,0-.246.228l-.059.065c-.071.079-.141.162-.206.252l-.04.053a3.213,3.213,0,0,0-.188.3c-.016.03-.034.059-.05.089-.057.109-.113.224-.162.343l-.044.107c-.05.125-.1.255-.141.392l-.024.081c-.036.127-.071.258-.1.394-.008.038-.018.073-.026.111-.032.152-.061.311-.087.476l-.022.141c-.024.168-.046.345-.061.525l-.01.121q-.024.261-.036.541l-.006.1c-.008.206-.012.42-.014.64v.153c0,.222,0,.45.012.686l.006.141c.008.254.02.509.038.779a18.546,18.546,0,0,0,.533,3.36c.995,3.939,3,7.24,3.8,11.855a20.1,20.1,0,0,1,.252,3.832c-.624.232-1.3.511-2,.85a19.257,19.257,0,0,0-3.543,2.209h0c-.129.1-.256.206-.382.311v0a.248.248,0,0,0-.04.034l-.012.006-.012.01-.008.01c-.192.162-.38.331-.567.5-.061.057-.121.119-.18.176-.121.115-.24.23-.357.351-.093.1-.184.2-.277.3-.077.083-.155.167-.232.254-.109.125-.216.256-.323.386-.038.046-.077.087-.113.133-.063.077-.129.156-.188.236A23.721,23.721,0,0,0,488.257,782a20.814,20.814,0,0,0-8.074-5.625q-.487-1.165-1.044-2.3c-.975-6.713-2.778-15.536-4.347-16.7-1.5-1.121-2.633-2.534-11.5-1.629-.252-.168-.505-.333-.757-.5a24.145,24.145,0,0,0,1.1-2.911q.155-2.158.125-4.25c1.69-.545,5.191-1.732,6.174-2.52,2.187-1.754-4.47-23.418-6.921-23.422-.866,0-5.324.539-7.341.789A36.424,36.424,0,0,0,424.8,707.8l-.987-2.229c-7.081.143-13.067,1.922-17.783,5.6l.553,1.841c-11.179,6.527-16.982,18.492-17.008,31-1.736.989-5.714,3.267-6.416,3.79-1.962,1.468,5.653,22.813,8.453,22.912,1.226.044,4.579-1.032,6.309-1.619.656.88,1.349,1.744,2.082,2.584-8.088,3.136-13.2,5.744-13.969,6.776-1.062,1.422.547,8.1,1.938,13.016-2.837,1.865-6.128,5.75-7.232,13.838-.057.4-.107.812-.151,1.234a3.973,3.973,0,0,0-1.635.791,5.539,5.539,0,0,0-1.341,1.5c-.079.129-.157.262-.232.4s-.153.3-.226.468c-.02.042-.038.085-.055.127-.059.143-.119.291-.174.446l-.034.093c-.065.186-.125.384-.18.59l-.03.115c-.049.186-.093.38-.135.583l-.014.063-.008.048c-.03.155-.057.317-.083.481-.008.052-.016.1-.024.155-.03.214-.056.432-.075.66v0a.061.061,0,0,0-.006.026s-.014-.034-.044-.091l0-.006-.059-.111-.038-.061-.055-.093-.048-.075c-.026-.038-.052-.079-.081-.123l-.055-.079c-.038-.052-.077-.1-.121-.161l-.055-.073c-.063-.079-.131-.16-.206-.248-.022-.026-.049-.053-.073-.079-.057-.065-.115-.129-.18-.2s-.119-.117-.178-.176l-.073-.073-.04-.036c-.05-.046-.1-.091-.149-.137-.1-.093-.21-.188-.329-.283l-.01-.008a10.847,10.847,0,0,0-1.191-.84l-.012-.006a15.616,15.616,0,0,0-3.945-1.651c-1.468-5.052-3.325-9.524-3.392-13.792-.071-4.684,1.288-8.3,1.532-12.358a18.652,18.652,0,0,0-.1-3.4c-.032-.267-.069-.523-.107-.773l-.02-.139c-.038-.232-.075-.458-.117-.676l-.028-.151c-.044-.216-.087-.426-.133-.626l-.024-.091c-.042-.182-.087-.357-.135-.525l-.032-.117q-.077-.262-.16-.505l-.046-.133c-.057-.156-.115-.309-.176-.452l-.046-.1c-.056-.129-.115-.254-.174-.37l-.038-.073c-.067-.127-.139-.246-.21-.36l-.063-.1c-.071-.107-.147-.21-.224-.307l-.065-.077a3.381,3.381,0,0,0-.24-.26l-.05-.046a3,3,0,0,0-.25-.208c-.024-.018-.046-.038-.071-.054a2.475,2.475,0,0,0-.281-.176l-.083-.044a2.657,2.657,0,0,0-.307-.137l-.065-.022a2.938,2.938,0,0,0-.3-.087l-.071-.018c-.113-.024-.23-.04-.351-.054l-.1-.008c-.121-.01-.244-.016-.37-.014l-.03,0c-.036,0-.071.006-.107.006-.052,0-.1,0-.157.008l-.157.014c-.052.006-.1.012-.158.02s-.105.014-.16.022-.119.02-.178.032l-.149.028c-.109.024-.222.047-.335.077-2.839.719-4.387,4.208-5.13,8.841-.143.9-.254,1.837-.341,2.807-.531,5.986-1.139,15.423-2.136,16.9a.8.8,0,0,1-.143.242c-.264.309-.935.571-2.38-1.474a38.877,38.877,0,0,1-3.309-6.2c-3.838-8.514-10.378-15.437-14.977-16.267a3.725,3.725,0,0,0-3,.58c-.107.079-.208.163-.3.246-.036.032-.067.063-.1.1-.059.054-.117.107-.17.164-.038.038-.071.077-.107.117s-.091.1-.133.153-.067.085-.1.129-.075.1-.109.153-.061.091-.089.139-.061.1-.091.155-.052.1-.075.145-.052.1-.075.158-.044.1-.063.149-.04.111-.059.167-.034.1-.049.151-.032.125-.048.186q-.03.122-.053.244c-.012.071-.026.143-.036.214-.006.055-.01.111-.016.167s-.012.115-.016.174,0,.117,0,.174,0,.115,0,.172,0,.121.006.18.006.117.01.174.01.121.016.182.014.119.022.178.016.121.026.182.022.123.034.186.022.121.036.18.028.127.044.192.028.119.044.178.04.141.059.21.036.125.055.186c.036.113.071.226.113.339.02.06.044.119.065.176s.05.137.075.2l.077.188c.028.063.053.129.081.194s.057.127.085.192l.087.188.1.2c.03.061.061.125.093.186l.1.2c.032.062.065.123.1.182s.073.135.111.2.065.117.1.174l.121.21c.028.047.057.1.085.143.178.3.367.59.561.882l.046.067c.061.093.127.184.19.277l.059.085c.065.093.131.184.2.277l.055.077c.071.095.141.192.212.287l.022.028a1.8,1.8,0,0,0,.9,1.133c.046.056.091.111.137.165.487.577.987,1.123,1.472,1.625,3.705,3.82,5.746,6.186,3,7.311-2.451,1.007-4.2-6.055-8.308-6.849l0,0a4.115,4.115,0,0,0-1.549,0c-5.257.985-7.077,6.434-4.082,9.049.129.111.264.224.4.337l.04.034a4.1,4.1,0,0,0,2.611,1.906l.2.139c2.958,2.033,6.188,4.157,6.071,5.718-.162,2.2-1.678,2.932-5.881,1.026a12.926,12.926,0,0,0-6.9-1.009c-2.047.313-3.578,1.278-3.618,2.978-.077,3.452,1.4,6.794,4,8.183a23.258,23.258,0,0,0,5.247,1.948c.894.236,1.853.462,2.909.719a1.3,1.3,0,0,1,.184.21c1.042,1.494.46,2.162-1.722,2.31-1.559.1-5.181.353-7.161,1.629l-.01,0a2.578,2.578,0,0,0-1.345,2.08c-.1,3.141,2.693,7.333,10.592,8.361.261.034.513.063.761.087l.1.012.256.026.3.022.232.018c.164.012.327.02.485.028.065,0,.133.008.2.01.17.008.337.01.5.014l.143,0c.2,0,.4,0,.588,0h.014c.4-.01.765-.034,1.112-.065l.107-.014c.131-.012.258-.028.38-.044.05-.006.1-.014.143-.022.107-.016.21-.032.311-.05.052-.008.1-.018.151-.028.093-.018.184-.036.271-.056l.147-.032c.083-.02.164-.04.244-.062l.139-.038.222-.065.127-.04.2-.071.113-.042c.067-.026.129-.052.192-.077l.1-.042c.065-.028.127-.057.186-.087l.075-.036c.083-.04.161-.081.236-.123l.018-.01a2.957,2.957,0,0,0,1.219-1.1,23.2,23.2,0,0,0,8.571,2.205L346.4,838s8.762,9.3,21.379,10.44a27.359,27.359,0,0,0,7.654-.365,29.4,29.4,0,0,0,5.982-1.815s5.356,1.472,12.922-2.823l.016-.01c.69-.392,1.4-.832,2.124-1.326,0,0,.269,1.207.689,2.542.1.305.2.616.305.921l-.008-.02s-.055.044-.153.125c-.065.053-.149.125-.25.212-.151.129-.339.291-.555.483-1.819,1.617-5.57,5.247-5.187,7.363.4,2.231,2.328,3.148,5.473,3.1-.268.158-1.413.836-2.851,1.722l-.026.012c-2.118,1.3-4.862,3.031-6.366,4.188l-.121.1-.012.008c-2.582,2.055-3.675,4.9-8.064,8.282-4.462,3.436-4.294,5.93-6.008,12.938-.747,3.057-1.555,6.115-2.225,8.6-.872,3.206-1.516,5.439-1.516,5.439a26.836,26.836,0,0,0-3,3.444l-.089.121-.032.046c-.044.06-.085.115-.129.176l-.071.1-.006,0v0a29.145,29.145,0,0,0-1.936,3.081,24.549,24.549,0,0,0-1.656,3.765,20.425,20.425,0,0,0-.652,2.3,64.415,64.415,0,0,0-1.24,9c-.083,1.209-.135,2.314-.164,3.265-.065,2.132-.026,3.491-.026,3.491a23.8,23.8,0,0,0-1.975,2.758l-.008.012a30.128,30.128,0,0,0-2.762,5.605,24.385,24.385,0,0,0-1.446,6.453c-.59,7.458,7.666,28.046,9.7,32.992-16.295-4.769-34.155-6.943-47.04-.438a18.4,18.4,0,0,0-4.3,2.647c-.337.25-.672.505-1,.771l.109.03a14.721,14.721,0,0,0-1.29,1.431,11.043,11.043,0,0,0-2.784,3.226c-.967,1.726-.573,4.834,1.135,8.863q.532,1.266,1.238,2.639a77.128,77.128,0,0,0,9.279,13.61c.539.656,1.1,1.312,1.68,1.977a130.318,130.318,0,0,0,9.794,10.059q.913.847,1.87,1.7c3.261,2.919,6.83,5.843,10.7,8.724.664.491,1.336.987,2.019,1.478a166.229,166.229,0,0,0,14.177,9.154c.719.416,1.446.83,2.183,1.236,4.357,2.429,8.964,4.747,13.812,6.9.773.345,1.547.684,2.332,1.019q6.331,2.707,13.2,5.021c.376.129.757.253,1.139.38h.01q.921-.125,1.817-.3c15.215-2.982,24.391-16.713,25.942-26.772a6.322,6.322,0,0,0,.089-.644,13.34,13.34,0,0,0-.612-6.618c-.894-3.872-2.913-9.2-7.287-15.746a64.5,64.5,0,0,0-4.288-8.49,172.166,172.166,0,0,0-.256-20.907c-1.034-10.577-4.414-18.8-3.862-24.478,0,0,5.051-2.33,9.2-19.829.517-2.164,1.014-4.557,1.488-7.206,0,0,.133-.038.375-.115,2.181-.7,13.329-4.7,17.727-14.587,4.888-10.983,9.792-12.57,12.413-10.87s13.673,12.221,29.9,11.428c0,0,.468,1.052,1.351,2.663v0a52.584,52.584,0,0,0,4.1,6.372c2.6,3.444,6.045,7.01,10.186,9a108.182,108.182,0,0,1,1.532,22.445c-.25,10.146.9,22.675,4.428,30.329a69.662,69.662,0,0,0,1.619,6.8c.709,7.846,2.485,13.257,4.22,16.832a13.366,13.366,0,0,0,3.681,5.532,5.886,5.886,0,0,0,.474.444c7.527,6.854,23.293,11.773,37,4.535.539-.283,1.072-.587,1.6-.907l.006-.006c.218-.339.436-.676.648-1.012q3.9-6.1,7.115-12.2.6-1.129,1.173-2.257c2.419-4.726,4.547-9.421,6.412-14.048q.473-1.171.921-2.334a166.571,166.571,0,0,0,5.28-16.029c.222-.81.434-1.617.642-2.417,1.2-4.67,2.136-9.188,2.841-13.507q.208-1.263.386-2.5a129.654,129.654,0,0,0,1.3-13.979c.034-.882.057-1.744.065-2.594A77.072,77.072,0,0,0,570.681,914.787Zm-204.23-13.006-.012.018.016-.024ZM397,854a3.513,3.513,0,0,1-.382-.052,1.973,1.973,0,0,1-.808-.313,1.082,1.082,0,0,1-.305-.327,1.154,1.154,0,0,1-.091-.194,1.385,1.385,0,0,1-.071-.44,3.642,3.642,0,0,1,.478-1.583c.1-.188.2-.376.317-.565.228-.376.483-.745.741-1.09.065-.085.129-.17.192-.252q.193-.25.374-.469c.543-.66.977-1.108.977-1.108A28.1,28.1,0,0,0,397,854Zm83.98-18.833,0,.016s6.713-1.179,7.755.315c.749,1.078.256,2.726-2.421,3.723a14.726,14.726,0,0,1-4.056.789c-.335-1.282-.773-2.706-1.337-4.292C480.918,835.718,480.943,835.522,480.979,835.167Z",
    transform: "translate(-307.298 -705.57)",
    opacity: 0.57,
    fill: "url(#linear-gradient-70)",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServerDown);
export default __webpack_public_path__ + "static/media/ServerDown.a9f7099069a030064cee44b2f015ad06.svg";
export { ForwardRef as ReactComponent };